export default {
  "account.disabled.contactUs": "If you think is a mistake, please contact us:",
  "account.disabled.contactUsVetting":
    "In order to get your user account operational, we need more information about your identity: please contact us through our website indicating in the message your company email address and the following code: <b>{code}</b> <br/><br/>We will evaluate your request and, if compliant, will enable your account as soon as possible.",
  "account.disabled.desc.customer":
    "Your account has been locked due to administrative problems or non-payment.<br/><br/>Please check your <a href='https://www.qboxmail.it/manager/clientarea.php' target='_blank'>customer area</a> for unpaid invoices.<br/>If there are any problems please contact us via <a href='https://www.qboxmail.it/manager/clientarea.php' target='_blank'>ticket</a>.",
  "account.disabled.desc.manager":
    "An administrative check is in progress. Contact the service manager for more information..",
  "account.disabled.desc.postmaster":
    "An administrative check is in progress. Contact the service manager for more information..",
  "account.disabled.desc.vetting":
    "To ensure high quality service and prevent abuse by malicious parties, our systems perform automatic checks on all newly registered users. <br/><br/>As a result of your registration, anomalies have been identified that could be caused by the fact that you are connecting via VPN or by entering incorrect or inconsistent contact information.",
  "account.disabled.title": "Your account is temporary locked",
  "account.disabled.titleVetting": "We need more details about your identity",
  "action.copied.password": "Password copied",
  "action.copy": "Copy",
  "action.download.example.csv": "Download example .CSV file",
  "action.download.verify.file": "Download verify file",
  "action.generateNewPassword": "Generate new password",
  "action.generateRandomPassword": "Generate random password",
  active: "active",
  activeF: "active",
  "additionalservices.requested.desc":
    "You have requested the activation of the {service} customisation. <br/> You will receive an email with details of the procedure shortly.",
  "additionalservices.requested.title": "Request sent",
  "admin.add.title": "New admin",
  "admins.list.header.dsc": "Admin users have access to all role and domain settings without restrictions.",
  "admins.list.header.title": "Admin",
  "alert.OTP.disabled": "OTP disabled",
  "alert.accountUpdatedSuccess": "Account updated successfully",
  "alert.admin.created": "Admin created",
  "alert.admin.deleted": "Admin deleted",
  "alert.admin.updated": "Admin updated",
  "alert.aliasDomainCreatedSuccess": "Domain alias created successfully",
  "alert.aliasEmailCreatedSuccess": "Email alias created successfully",
  "alert.cannotEditWhileDisabled": "You cannot edit anything while domain is disabled",
  "alert.check.DNS.success": "Check queuing successfully",
  "alert.code.notValid": "Code not valid",
  "alert.customer.created": "Customer created",
  "alert.customer.disabled": "Cannot enable because customer is disabled",
  "alert.customer.updated": "Customer updated",
  "alert.customization.deleted": "Customization deleted",
  "alert.customizationCreatedSuccess": "Theme created successfully",
  "alert.customizationUpdatedSuccess": "Theme updated successfully",
  "alert.delegateDeletedSuccess": "Delegate deleted successfully",
  "alert.delegateUpdatedSuccess": "Delegate updated successfully",
  "alert.deliveryAccount.updated": "Account updated",
  "alert.deliveryDomain.approvalSkip.success": "Approval skipped successfully",
  "alert.deliveryDomain.updated": "Domain updated",
  "alert.deliveryDomain.verification.fail": "Verification failed. Check verification parameters.",
  "alert.deliveryDomain.verification.success": "Verification operation successfully completed",
  "alert.destinations.updated": "Destinations updated",
  "alert.domain.problem": "There was some problem with this domain, please contact us",
  "alert.domainCreatedSuccess": "Domain created successfully",
  "alert.domainUpdateSuccess": "Domain updated successfully",
  "alert.emailCreatedSuccess": "Email created successfully",
  "alert.emailUpdatedSuccess": "Email updated successfully",
  "alert.error.validation": "Validation error",
  "alert.import.deleted": "Import deleted",
  "alert.importCreatedSuccess": "Import created successfully",
  "alert.invalidFileCSVFormat": "You can upload only one .CSV or .TXT",
  "alert.invalidFileImageFormat": "You can upload only one .PNG or .JPEG",
  "alert.ipAddressAlreadyListed": "{ip} is already in the list",
  "alert.ipAddressInvalid": "{ip} is not a valid ip address",
  "alert.loginSuccess": "Login successful",
  "alert.managerCreatedSuccess": "Manager created successfully",
  "alert.managerDeletedSuccess": "Manager deleted successfully",
  "alert.managerUpdatedSuccess": "Manager updated successfully",
  "alert.migration.deleted": "Migration deleted",
  "alert.migration.options.uploaded": "Opzione migrazione caricata",
  "alert.migrationCreateSuccess": "Migration created successfully",
  "alert.missingFile": "You need to upload a .CSV or .TXT file",
  "alert.mxAlreadyExists": "This pair of addresses already exists",
  "alert.operationError": "Error during the operation",
  "alert.operationSuccess": "Operation success",
  "alert.option.deleted": "Option deleted",
  "alert.order.deleted": "Order deleted",
  "alert.orderUpdatedFailed": "Order update failed",
  "alert.orderUpdatedSuccess": "Order updated successfully",
  "alert.orders.errorOnNew": "Error in placing the order",
  "alert.otpInvalid": "OTP not valid",
  "alert.otpValid": "OTP valid",
  "alert.ownershipCheckFail": "Ownership check failed",
  "alert.ownershipCheckSuccess": "Ownership check successful, domain is enqueued for activation",
  "alert.ownershipEmailSent": "Email sent to ",
  "alert.password.updated": "Password updated",
  "alert.registration.completed": "Registration completed",
  "alert.resetEmailSended": "Email with instruction sent, check your messages",
  "alert.session.exiped": "Session expired, please try again",
  "alert.ssoError": "Link is not valid",
  "alert.successfullyCopied": "Copied",
  "alert.suppressionList.edit.success": "Suppression list successfully updated",
  "alert.teamMemberCreatedSuccess": "Team member created successfully",
  "alert.teamMemberDeletedSuccess": "Team member deleted successfully",
  "alert.teamMemberUpdatedSuccess": "Team member updated successfully",
  "alert.ticket.sent": "Ticket sent",
  "alert.validationFailed": "Validation failed",
  "alert.verificationDKIMFailed": "Verification failed, check your configuration and try later",
  "alert.verificationFailed": "Verification failed",
  "alert.verificationSuccess": "Verification successful",
  "alert.wrong": "Something went wrong",
  "alert.wrong.contactUs": "Something went wrong, contact us",
  all: "All",
  "archive.add.desc.step1":
    "Select the email accounts on which to activate the archive. <b>The number of accounts on which the archive can be activated varies according to the domain settings</b>.",
  "archive.add.desc.step2":
    "Set the default retention period for messages from archived accounts. <b>Messages whose date exceeds the chosen retention period will be automatically deleted from the archive</b>.",
  "archive.add.desc.step3":
    "Set the default retention period for new domain accounts. <b>The archive will be automatically activated on new email accounts until the number of available files is reached</b>, based on the domain settings.",
  "archive.add.desc.step4":
    "The archive activation is immediate. The cost will be calculated based on the billing type of your account.",
  "archive.add.desc.step5":
    "The archive has been successfully activated. An email has been sent to you with instructions for managing the storage system.<br/>On the <b>next invoice</b> you will find the entry <code>Archive</code> related to the service.",
  "archive.add.title.step1": "New archive",
  "archive.add.title.step2": "Archive retention",
  "archive.add.title.step3": "Archive new accounts",
  "archive.add.title.step4": "New archive summary",
  "archive.add.title.step5": "Archive activated",
  "archive.firstView.desc":
    "Store your emails automatically, safely and transparently.<br/>Archive is an <b>additional paid service</b> that saves and stores in the cloud a copy of all messages sent and received, without software or installation plugins.<br/><br/>Archived messages are on read-only and are stored up to 10 years.<br/>You can import and store your message history.<br/><br/>The Archive activation is immediate and the cost is calculated based on the chosen payment plan.",
  "archive.firstView.legalAd":
    "Before activating Archive, it is advisable to consult an expert in legal matters in order to respect the local law for your company.<br/>If necessary, inform your employees about the operation and the legal requirements of the service.",
  "archive.firstView.noArchive": "You have not archive available for activation.",
  "archive.firstView.title": "Active archive",
  "archive.import.faileMsg": "There were problems during import process.<br />Contact us for more information.",
  "archive.import.loadingMsg":
    "<b>Import in progress.</b><br/>The operation may take a few hours. You will receive a confirmation email at the end of the procedure.",
  "archive.import.successMsg":
    "<b>Import process completed successfully.</b><br/>You will find the messages divided by year, sorted between received and sent, as you chosen.",
  "archive.import.warningMsg": "Import can be done only once",
  "archive.list.header.dsc":
    "Archive allows you to store, search and export all incoming and outgoing messages of an account up to 10 years without space limit.",
  "archive.list.header.title": "Archive",
  "audits.list.header.dsc": "Audit log show all activities related to the management of services performed by users.",
  "audits.list.header.title": "Audit log",
  "banner.tryDelivery.cta": "Try the service for free",
  "banner.tryDelivery.desc":
    "The <b>Email Delivery</b> service is dedicated to sending large volumes of promotional and transactional email messages via the SMTP protocol.",
  "banner.tryDelivery.title": "Need to send more?",
  "beta.delivery.accounts.add.modal.contentMessage":
    "To be able to use the account you must associate at least one domain.",
  "beta.delivery.accounts.add.modal.info": "You'll receive an email with a recap.",
  "beta.delivery.accounts.add.modal.title": "Account successfully activated",
  "beta.delivery.accounts.credentials.modal.backButton": "Back to summary",
  "beta.delivery.accounts.credentials.modal.forwardButton": "Go to the accounts list",
  "beta.delivery.accounts.step2.warningMsg":
    "In the Beta version, it is only possible to subscribe to the Free Trial plan with 5000 monthly mailings.",
  "butto.info.hide": "Less info",
  "butto.info.show": "More info",
  "button.HTMLfile": "Generate .HTML file",
  "button.active": "Active",
  "button.add": "Add",
  "button.add.address": "Address",
  "button.add.customer": "Customer",
  "button.add.customization": "Theme",
  "button.add.delegate": "Delegate",
  "button.add.toList": "Add to list",
  "button.addAdmin": "Admin",
  "button.addAlias": "Alias domain",
  "button.addAliasEmail": "Alias email",
  "button.addArchive": "Archive",
  "button.addDomain": "Domain",
  "button.addDomainFull": "Add Domain",
  "button.addEmail": "Email account",
  "button.addManager": "Manager",
  "button.addTeamMember": "Team member",
  "button.advanced.domainInfo.hide": "Hide extended information",
  "button.advanced.domainInfo.show": "Show extended information",
  "button.advanced.filters.hide": "Hide filters",
  "button.advanced.filters.show": "Show filters",
  "button.approveDomain": "Approve and activate the domain",
  "button.assignAccountOrDomain": "Edit managed resources",
  "button.back": "Back",
  "button.back.domains": "Back to domains",
  "button.backCustomers": "Back to customers list",
  "button.backOrder": "Back to the order",
  "button.buy": "Buy",
  "button.buyExtraDelivery": "Buy extra email messages",
  "button.buyMailboxes": "Buy mailboxes",
  "button.buyPlan": "Buy a plan",
  "button.cancel": "Cancel",
  "button.change": "Change",
  "button.changePlan": "Change plan",
  "button.checkOTP": "Check OTP",
  "button.close": "Close",
  "button.confirm": "Confirm",
  "button.contactUs": "Contact us",
  "button.continue": "Continue",
  "button.convertMonthly": "Convert to monthly",
  "button.copy": "Copy",
  "button.create": "Create",
  "button.createAccount": "Create account",
  "button.createDelegate": "Create delegate",
  "button.createDomain": "Create domain",
  "button.days": "Days",
  "button.delete": "Delete",
  "button.delete.deliveryAccount": "Delete account",
  "button.delete.domain": "Delete domain",
  "button.deleteOrder": "Delete order",
  "button.deliveryWaitlistAccept": "Unlock access to the service",
  "button.details.hide": "Hide",
  "button.details.show": "Details",
  "button.disable": "Disable",
  "button.disableDKIM": "Disable DKIM",
  "button.disableOTP": "Disable OTP",
  "button.docs": "Documentation",
  "button.download.report": "Download report",
  "button.edit": "Edit",
  "button.enable": "Enable",
  "button.enableDKIM": "Enable DKIM",
  "button.enableOTP": "Enable OTP",
  "button.expandTable": "Show all",
  "button.export.exportSuppressionListCompleted": "Export completed",
  "button.export.exportingSuppressionList": "Creating the file...",
  "button.export.suppressionList": "Export suppression list",
  "button.exportCSV": "Export CSV",
  "button.fillTheForm": "Fill the form",
  "button.filter": "Filter",
  "button.force.change": "Force change",
  "button.forgottenPassword": "Forgot password?",
  "button.generate.code": "Generate code",
  "button.generate.password": "Generate new password",
  "button.generate.token": "Generate token",
  "button.goToArchive": "Manage archive",
  "button.goToHome": "Return to home",
  "button.goToSettings": "Go to settings",
  "button.goToVerification": "To verification",
  "button.hide": "Hide",
  "button.import": "Import",
  "button.import.list": "Import list",
  "button.insert": "Insert",
  "button.loadMore": "Load more",
  "button.loading": "Loading",
  "button.login": "Log in",
  "button.logout": "Logout",
  "button.manage.delegates": "Mange delegates",
  "button.manage.domains": "Mange domains",
  "button.migrate": "Add Migration",
  "button.modifyPlan.cancel": "Cancel change request",
  "button.modifyPlan.monthly": "Change messages included in the plan",
  "button.moreMessages": "Increase number of messages",
  "button.mtmRestore.accept": "Accept request",
  "button.mtmRestore.deny": "Deny request",
  "button.new.signature": "New signature",
  "button.new.ticket": "New ticket",
  "button.newDomainArchive": "Enable archive",
  "button.newImport": "Import",
  "button.newMigration": "Migration",
  "button.next": "Next",
  "button.ok": "Ok",
  "button.openIn.newWindow": "Open in new tab",
  "button.order": "Order",
  "button.order.cancel": "Cancel request",
  "button.passwordChange": "Change password",
  "button.passwordRecovery": "Recovery password",
  "button.passwordReset": "Password reset",
  "button.passwordSet": "Set password",
  "button.pay": "Pay",
  "button.pickPlan": "Pick a plan",
  "button.regenerate.code": "Regenerate code",
  "button.remove": "Remove",
  "button.remove.link": "Rimuovi link",
  "button.requestAccess": "Request access",
  "button.reset": "Reset",
  "button.reset.token": "Reset token",
  "button.resetProcedure": "Reset procedure",
  "button.restore.deliveryAccount": "Restore subscription",
  "button.run.migration.first": "Run 1°",
  "button.run.migration.second": "Run 2°",
  "button.save": "Save",
  "button.saveApply": "Save & Apply",
  "button.search": "Search",
  "button.see.proforma": "Pay now",
  "button.send.ticket": "Send ticket",
  "button.sendVerifyEmail": "Send verification email",
  "button.servicesAndBilling": "Services and billing",
  "button.setSignature": "Apply Signature",
  "button.show": "Show",
  "button.showDNSConfig": "Show DNS configuration",
  "button.showLog": "Show log",
  "button.showServerResponse": "Show server response",
  "button.skipDeliveryDns": "Enable without DNS check",
  "button.skipOwnershipCheck": "Skip ownership check",
  "button.startImport": "Start import",
  "button.understood": "Understood",
  "button.update": "Update",
  "button.upgradeAccounts": "Add email accounts",
  "button.upgradePlan": "Plan upgrade",
  "button.verify": "Verify",
  "button.verifyDKIM": "Verify DKIM",
  "button.verifyDNS": "Verify DNS",
  "button.verifyMX": "Verify MX",
  "buttonIcons.add.image": "Add image",
  "buttonIcons.bold": "Bold",
  "buttonIcons.delete": "Delete",
  "buttonIcons.edit": "Edit",
  "buttonIcons.insert.HTML": "Insert HTML",
  "buttonIcons.insert.link": "Insert link",
  "buttonIcons.italic": "Italic",
  "buttonIcons.remove.formatting": "Remove formatting",
  "buttonIcons.remove.link": "Remove link",
  "buttonIcons.strike": "Strike",
  "buttonIcons.underline": "Underline",
  "confirmationModal.text.delete.admin":
    "You are trying to delete <code>{nameAdmin}</code>.<br/><b>This operation cannot be reversed.</b>",
  "confirmationModal.text.delete.customer":
    "You are trying to delete <code>{customerName}</code>.<br/>Deleting the customer all its resources will be deleted.<br/><b>This operation cannot be reversed.</b>",
  "confirmationModal.text.delete.domainAlias":
    "You are trying to delete the do alias <code>{domainAliasName}</code>.<br/><b>This operation cannot be reversed.</b>",
  "confirmationModal.text.delete.domains":
    "You are trying to delete <code>{domainName}</code>.<br/>Deleting the domain you will lose its email accounts and aliases connected to it. <b>This operation cannot be reversed.</b>",
  "confirmationModal.text.delete.emailAlias":
    "You are trying to delete the email alias <code>{emailAliasName}</code>.<br/><b>This operation cannot be reversed.</b>",
  "confirmationModal.text.delete.order":
    "By canceling the order, all the data entered during the procedure will be deleted and a new order will have to be made.",
  "confirmationModal.text.delivery.samePlan":
    "The plan is the same as the current one, choose a different plan to proceed",
  "confirmationModal.title.delete.admin": "Delete admin",
  "confirmationModal.title.delete.domainAlias": "Delete domain alias",
  "confirmationModal.title.delete.emailAlias": "Delete email alias",
  "confirmationModal.title.delete.order": "Delete order",
  "confirmationModal.title.delete.suppressionList": "Remove from suppression list",
  "confirmationModal.title.delivery.samePlan": "Attention",
  "confirmationModal.title.delte.customer": "Delete customer",
  "confirmationModal.title.delte.domain": "Delete domain",
  "customer.add.title": "New customer",
  "customers.list.header.dsc":
    "Customers can manage domains and other administrative roles within the limits assigned to them.",
  "customers.list.header.title": "Customers",
  "customizations.add.domains.desc":
    "Set a customization for the domains you prefer. The logo and other information will be displayed in all services connected to the selected domains.",
  "customizations.add.domains.title": "New domains customization",
  "customizations.add.general.desc":
    "Set a general customization to apply to domains that you manage, if you do not have a specific customization for each domain. <b>Only one general customization can be entered.</b>",
  "customizations.add.general.title": "New general customization",
  "customizations.collaboration": "in collaboration with",
  "customizations.edit.domains.title": "Edit domains customization",
  "customizations.edit.general.title": "Edit general customization",
  "customizations.list.header.dsc":
    "Customizations allow you to customize your services with your company logo and name.",
  "customizations.list.header.title": "Customizations",
  "customizations.show.desc.domains":
    "Customizations by domain are applied only to specific domains (with professional or enterprise plan). The logo and other information will be displayed in all services connected to the selected domains.",
  "customizations.show.desc.general":
    "The general customization is applied to all domains that you manage, if you do not have a specific customization for each domain. Your logo and other information will be displayed in all services. <b>Only one general customization can be entered.</b>",
  "customizations.show.desc.managers":
    "These are general customizations created by your mangers. Management it is completely handled by them",
  "dashboard.chart.title.alias.domain.active": "Domains alias activated",
  "dashboard.chart.title.alias.email.active": "Email alias activated",
  "dashboard.chart.title.domains.active": "Domains activated",
  "dashboard.chart.title.emails.active": "Email accounts activated",
  "dashboard.chart.title.maxQuota.email": "Email accounts for maximum quota",
  "dashboard.chart.title.topQuota.domain": "Top domains occupied space",
  "dashboard.deliveryAnalytics.title": "Detail of sent messages",
  "dashboard.extraDelivery.desc":
    "Extra messages allow you to continue sending even if you run out of messages included in your subscription. They do not expire and can be used as long as the account remains active.",
  "dashboard.extraDelivery.title": "Extra Email Messages",
  "dashboard.label.accounts_disabled": "Disabled accounts",
  "dashboard.label.accounts_enabled": "Active accounts",
  "dashboard.label.alias_domains": "Domains alias",
  "dashboard.label.alias_email_accounts": "Emails alias ",
  "dashboard.label.customers_disabled": "Disabled customers",
  "dashboard.label.customers_enabled": "Enabled customers",
  "dashboard.label.domainActivations": "Domain activations",
  "dashboard.label.domainAliasActivations": "Domain alias activation",
  "dashboard.label.domains_disabled": "Disabled domains",
  "dashboard.label.domains_enabled": "Active domains",
  "dashboard.label.domains_only_postmaster": "Domains without email accounts",
  "dashboard.label.emailAccountsPerQuota": "Account by size",
  "dashboard.label.emailActivations": "Accounts activation",
  "dashboard.label.emailAliasActivations": "Email alias activation",
  "dashboard.label.email_accounts_100gb_disabled": "Disabled 100GB accounts",
  "dashboard.label.email_accounts_100gb_enabled": "Active 100GB accounts",
  "dashboard.label.email_accounts_25gb_disabled": "Disabled 25GB accounts",
  "dashboard.label.email_accounts_25gb_enabled": "Active 25GB accounts",
  "dashboard.label.email_accounts_50gb_disabled": "Disabled 50GB accounts",
  "dashboard.label.email_accounts_50gb_enabled": "Active 50GB accounts",
  "dashboard.label.email_accounts_8gb_disabled": "Disabled 8GB accounts",
  "dashboard.label.email_accounts_8gb_enabled": "Active 8GB accounts",
  "dashboard.label.email_accounts_archive_disabled": "Disabled archive",
  "dashboard.label.email_accounts_archive_enabled": "Enabled archive",
  "dashboard.label.mail_overquota": "Overquota mailboxes",
  "dashboard.label.managers": "Managers",
  "dashboard.label.postmaster_domain_disabled": "Disabled postmasters",
  "dashboard.label.postmaster_domain_enabled": "Enabled postmasters",
  "dashboard.label.team_members": "Team members",
  "dashboard.label.top10DomainsQuota": "Top 10 domains overquota",
  "dashboard.label.top10EmailsQuota": "Top 10 accounts overquota",
  "dashboard.list.header.title": "Dashboard",
  "dashboard.messagesDetails.desc": "Detail of processed messages sent by the account and divided by days.",
  "dashboard.messagesDetails.title": "Messages sent by the account",
  "dashboard.messagesPerDomain.desc":
    "Details of processed messages sent from the domains associated with the account.",
  "dashboard.messagesPerDomain.title": "Messages sent by domains",
  "dashboard.planDetails.free.content.title": "Free Plan",
  "dashboard.planDetails.monthly.content.title": "Monthly Subscription",
  "dashboard.planDetails.prepaid.content.title": "Prepaid Plan",
  "ddMenu.cancel": "Cancel",
  "ddMenu.delete": "Delete",
  "ddMenu.disable": "Disable",
  "ddMenu.enable": "Enable",
  "ddMenu.logout": "Logout",
  "ddMenu.manage.account": "Manage account",
  "ddMenu.settings": "Settings",
  "ddMenu.suppressionListDeliver": "Enable delivery",
  "ddMenu.suppressionListDontDeliver": "Block delivery",
  "ddMenu.tour": "Tour",
  "delegate.add.desc.step1": "Enter the contact information of the user you want to authorize to view the archive.",
  "delegate.add.desc.step2":
    "Set the expiration date of the delegate's authorization and the storage time interval for which he can view. <b/>On the selected date the authorization will be automatically revoked and the delegate will be deactivated</b>.",
  "delegate.add.desc.step3":
    "Select the accounts that the delegate can view. The delegate can be authorized to view multiple domain accounts.<br/><br/><b>Subject:</b> view of sender/recipient, subject and date of messages<br/><b>All:</b> complete view of messages content<br/><b>Ignore:</b> unauthorized access to content",
  "delegate.add.desc.step4":
    "The delegate will be active immediately. An email will be sent to the user indicated with credentials and access instructions. The delegate will automatically cease to exist at the chosen deadline.",
  "delegate.add.desc.step5":
    "Delegate <b>{name}</b> was successfully created. An email with instructions to access the storage system has been sent to <code>{emailAddress}</code>.<br/><br/>Delegate UserID: <code>{userID}</code>",
  "delegate.add.title.step1": "New delegate",
  "delegate.add.title.step2": "Time limits",
  "delegate.add.title.step3": "Content access",
  "delegate.add.title.step4": "New delegate summary",
  "delegate.add.title.step5": "Delegate created!",
  "delegates.firstView.desc":
    "Allow who can view stored messages.<br/>Delegates are users authorized to read only, part or all of the content of the stored messages of one or more email accounts, within a defined time interval.<br/><br/>The account will be automatically removed if all the email accounts assigned to the delegate will be removed.<br/><b>Creating a delegate is not required to use Archive.</b>",
  "delegates.firstView.title": "Enable delegates",
  "delegates.firstView.warningMsg": "It is necessary to activate the archive on one email account at least.",
  "delegates.list.header.dsc":
    "Delegates are users authorized to access the content of one or more archives within certain limits.",
  "delegates.list.header.title": "Delegates",
  "delivery.accessRequest.step1.desc":
    "Email Delivery is the Qboxmail service designed for sending large volumes of email messages via the SMTP protocol. The service is designed for customers who need to send email messages directly from their applications such as e-commerce, management and billing software, marketing applications for sending newsletters, simply by setting the traditional SMTP protocol. The service is currently available for free in beta version",
  "delivery.accessRequest.step1.docsLink": "Learn more...",
  "delivery.accessRequest.step1.servicesOptions.none": "None",
  "delivery.accessRequest.step1.servicesOptions.other": "Other",
  "delivery.accessRequest.step1.servicesOptions.server": "Dedicated server",
  "delivery.accessRequest.step1.title": "Email Delivery",
  "delivery.accessRequest.step2.desc":
    "Answer the following questions to request access to the free beta version of Email Delivery service. You'll be placed on the waiting list and you'll be notified as soon as the access becomes available.",
  "delivery.accessRequest.step2.similarServices.title": "Did you already use a similar service?",
  "delivery.accessRequest.step2.title": "Request for access to Email Delivery service",
  "delivery.accessRequest.step2.totalEmailsEstimate.placeholder": "Indicates a rough estimate",
  "delivery.accessRequest.step2.totalEmailsEstimate.title": "How many emails do you plan to send in a month?",
  "delivery.accessRequest.step2.type.title": "What type of email messages would you like to send?",
  "delivery.accessRequest.step3.desc":
    "We have taken over your request and we'll let you know as soon as possible if you meet the requirements to access the free beta version of Email Delivery service.",
  "delivery.accessRequest.step3.title": "Thanks for requesting access",
  "delivery.accessRequest.warningUnpaid": "Only customers with an active paid plan can access to the beta service.",
  "delivery.account.status.disabled": "Disabled by system",
  "delivery.account.status.disabledByCustomer": "Disabled",
  "delivery.account.status.enabled": "Active",
  "delivery.account.status.scheduledDeleting": "Active",
  "delivery.account.status.updating": "Updating",
  "delivery.account.status.waitingCustomerApproval": "Waiting for approval",
  "delivery.account.status.waitingCustomerApprovalFull": "Waiting for provider approval",
  "delivery.account.status.waitingPayment": "Waiting for payment",
  "delivery.accounts.add.extraDelivery.packages.title": "How many packages do you want to purchase?",
  "delivery.accounts.add.step1.desc":
    "Create a new account by subscribing to a sending plan. Once created, you will need to associate it with at least one domain authorized for sending.",
  "delivery.accounts.add.step1.description.desc":
    "Enter a description that will help you remember what to use this account for (e.g. “Hotel newsletter“, “Hotel booking confirmation“)",
  "delivery.accounts.add.step1.description.title": "Description",
  "delivery.accounts.add.step1.title": "New account",
  "delivery.accounts.add.step1.type.both.label": "Both",
  "delivery.accounts.add.step1.type.desc": "Select the email type you want to send with your account.",
  "delivery.accounts.add.step1.type.marketing.desc":
    "Promotional emails are bulk emails delivered to many recipients (future customers or actual customers) for marketing purpose, such as advertising email campaigns, newsletters, ecc...",
  "delivery.accounts.add.step1.type.marketing.label": "Promotional emails",
  "delivery.accounts.add.step1.type.title": "Email type",
  "delivery.accounts.add.step1.type.transaction.desc":
    "Transactional emails are delivered to a specific recipient to confirm an action or to notify an event, such as confirm an order, bills, ecc...",
  "delivery.accounts.add.step1.type.transaction.label": "Transactional emails",
  "delivery.accounts.add.step2.betaBanner.description":
    "In the Beta version, it is only possible to subscribe to the Free Trial plan with 5000 monthly mailings.",
  "delivery.accounts.add.step2.betaBanner.title": "ONLY FREE TRIAL PLAN AVAILABLE",
  "delivery.accounts.add.step2.desc": "Select the plan for this account and its sending volumes.",
  "delivery.accounts.add.step2.freePlanPriceRecap": "Free",
  "delivery.accounts.add.step2.plan.free.label": "Free trial",
  "delivery.accounts.add.step2.plan.monthly.label": "Monthly subscription",
  "delivery.accounts.add.step2.plan.msg": "Select the type of plan",
  "delivery.accounts.add.step2.plan.prepaid.label": "Prepaid",
  "delivery.accounts.add.step2.plan.title": "Type",
  "delivery.accounts.add.step2.priceRecapLabel": "Price",
  "delivery.accounts.add.step2.title": "Plan",
  "delivery.accounts.add.step2.volume.label": "TODO: Send 5000 emails per month",
  "delivery.accounts.add.step2.volume.msg": "How many emails do you want to send monthly?",
  "delivery.accounts.add.step2.volume.title": "Number of email messages",
  "delivery.accounts.add.step3.billRecap.message1":
    "The indicated price refers to the cost of the service for the entire month. The exact amount of the first invoice, which you will receive via email, will be calculated based on the order completion date.",
  "delivery.accounts.add.step3.billRecap.message2":
    "The cost of the monthly subscription does not include the cost of extra email messages. Extra email messages will be charged to the invoice only if used, at the price of €1.00 for every 1,000 messages.",
  "delivery.accounts.add.step3.billRecap.title": "Monthly bill",
  "delivery.accounts.add.step3.desc": "Here you can find the summary of the account configuration",
  "delivery.accounts.add.step3.serviceRecap.plan": "Plan",
  "delivery.accounts.add.step3.serviceRecap.type": "Email type",
  "delivery.accounts.add.step3.serviceRecap.volume": "Number of email messages",
  "delivery.accounts.add.step3.title": "Summary",
  "delivery.accounts.add.step4.desc":
    "You need username and password to be able to use the account. They should be added into your email client in order to access.",
  "delivery.accounts.add.step4.downloadAsCsv": "Download all the account data as .csv",
  "delivery.accounts.add.step4.title": "Username and password",
  "delivery.accounts.add.step4.warningMsg":
    "Warning! You need to save the password in a safe place: in case of loss you can only generate a new one",
  "delivery.accounts.add.stepBillingInfo.desc": "Enter all the necessary information for the service billing.",
  "delivery.accounts.add.stepBillingInfo.title": "Billing Information",
  "delivery.accounts.add.stepCredentials.desc":
    "To use this account, you will need the username and password provided below. They have to be entered into your application in order to log in and send messages.",
  "delivery.accounts.add.stepCredentials.downloadAsCsv": "Download all account data in .csv format",
  "delivery.accounts.add.stepCredentials.parameters": "Parameters",
  "delivery.accounts.add.stepCredentials.parametersSaved": "I have saved the parameters",
  "delivery.accounts.add.stepCredentials.title": "Configuration for sending",
  "delivery.accounts.add.stepCredentials.warningMsg":
    "Attention! It is important to save the password in a secure place: if lost, it will only be possible to generate a new one.",
  "delivery.accounts.add.stepCustomerType.desc":
    "Indicate whether you intend to use the service for yourself, for your company, or if you plan to purchase it to resell to others.",
  "delivery.accounts.add.stepCustomerType.title": "Customer Type",
  "delivery.accounts.add.stepCustomerType.typeSelection.company.label": "Company",
  "delivery.accounts.add.stepCustomerType.typeSelection.private.label": "Private [residents in Italy only]",
  "delivery.accounts.add.stepCustomerType.typeSelection.reseller.label": "Reseller",
  "delivery.accounts.add.stepCustomerType.typeSelection.title": "Select the type of customer that represents you",
  "delivery.accounts.add.stepPaymentMethod.additionalBilling.title":
    "Specify an additional contact for receiving invoices (optional)",
  "delivery.accounts.add.stepPaymentMethod.credentials.desc": "Your customer area login credentials are:",
  "delivery.accounts.add.stepPaymentMethod.credentials.title": "Customer Area login credentials",
  "delivery.accounts.add.stepPaymentMethod.customerAreaCredentials.label":
    "Use different credentials to access the customer area",
  "delivery.accounts.add.stepPaymentMethod.customerAreaCredentials.password":
    "The password you use to access the control panel",
  "delivery.accounts.add.stepPaymentMethod.desc":
    "Choose the payment method that best suits your needs and select the access credentials for the billing system",
  "delivery.accounts.add.stepPaymentMethod.payment.title": "Select the payment method",
  "delivery.accounts.add.stepPaymentMethod.title": "Payment Method",
  "delivery.accounts.add.stepPlan.betaBanner.description":
    "In the Beta version, it is only possible to subscribe to the Free Trial plan with 5000 monthly mailings.",
  "delivery.accounts.add.stepPlan.betaBanner.title": "ONLY FREE TRIAL PLAN AVAILABLE",
  "delivery.accounts.add.stepPlan.changeDesc":
    "Upon activation of the new plan, <b>the remaining messages of the current month will be lost</b>.",
  "delivery.accounts.add.stepPlan.changeDescMonthToPrepaid":
    "Extra email messages are available only for Monthly Subscriptions, if you change the type of plan <b>you will lose the remaining extra email messages</b>. <br/>Upon activation of the new plan, <b>the remaining messages of the current month will be lost</b>.",
  "delivery.accounts.add.stepPlan.changeDescPrepaid":
    "The new package purchased will be added to the current balance. The expiration will be adjusted for all remaining messages.",
  "delivery.accounts.add.stepPlan.changeDescPrepaidToMonth":
    "Upon activation of the new plan, <b>remaining messages will be lost</b>.",
  "delivery.accounts.add.stepPlan.changeRecapCreditNext": "Your next balance",
  "delivery.accounts.add.stepPlan.changeRecapCreditNow": "Your balance",
  "delivery.accounts.add.stepPlan.changeRecapTitleNext": "Your next plan",
  "delivery.accounts.add.stepPlan.changeRecapTitleNow": "Your current plan",
  "delivery.accounts.add.stepPlan.desc": "Select the plan for this account and its sending volumes.",
  "delivery.accounts.add.stepPlan.disclaimer":
    "Once the payment is completed your current plan will be terminated and you will lose the remaining messages. Your new plan will be immediately available.",
  "delivery.accounts.add.stepPlan.footerMsg":
    "Purchased messages are valid for 12 months; the expiry is extended in the event of a subsequent purchase.",
  "delivery.accounts.add.stepPlan.freePlanPriceRecap": "Free",
  "delivery.accounts.add.stepPlan.monthlyNumberOfMessages": "Monthly messages",
  "delivery.accounts.add.stepPlan.monthlyPrice": "Monthly price",
  "delivery.accounts.add.stepPlan.monthlyResellerPrice": "Monthly price for resellers",
  "delivery.accounts.add.stepPlan.numberOfMessages": "Messages",
  "delivery.accounts.add.stepPlan.plan.free.label": "Free",
  "delivery.accounts.add.stepPlan.plan.monthly.label": "Monthly subscription",
  "delivery.accounts.add.stepPlan.plan.msg": "Select the type of plan",
  "delivery.accounts.add.stepPlan.plan.prepaid.label": "Prepaid",
  "delivery.accounts.add.stepPlan.plan.title": "Type",
  "delivery.accounts.add.stepPlan.prepaid.volume.msg": "How many messages to send do you want to buy?",
  "delivery.accounts.add.stepPlan.price": "Price",
  "delivery.accounts.add.stepPlan.priceRecapLabel": "Price",
  "delivery.accounts.add.stepPlan.resellerPrice": "Reseller price",
  "delivery.accounts.add.stepPlan.title": "Plan",
  "delivery.accounts.add.stepPlan.volume.label": "Send 5000 emails per month",
  "delivery.accounts.add.stepPlan.volume.msg": "How many emails do you want to send monthly?",
  "delivery.accounts.add.stepPlan.volume.title": "Number of email messages",
  "delivery.accounts.add.stepRecap.billRecap.message.monthly":
    "The amount indicated refers to the entire month. The exact amount of the first invoice, which you will receive by email, will be calculated according to the order completion date.",
  "delivery.accounts.add.stepRecap.billRecap.message2":
    "The cost of the monthly subscription does not include the cost of extra email messages. Extra email messages will be charged to the invoice only if used, at the price of €1.00 for every 1,000 messages.",
  "delivery.accounts.add.stepRecap.billRecap.title": "Monthly bill",
  "delivery.accounts.add.stepRecap.desc": "Here you can find the summary of the account configuration",
  "delivery.accounts.add.stepRecap.modal.info.free": "You will receive an email with a summary of the data.",
  "delivery.accounts.add.stepRecap.modal.info.pay":
    "You will receive an email with a summary of the order placed and details for payment. The account will be activated as soon as the payment is recorded.",
  "delivery.accounts.add.stepRecap.modal.title.free": "Account activated successfully",
  "delivery.accounts.add.stepRecap.modal.title.pay": "Order placed",
  "delivery.accounts.add.stepRecap.serviceRecap.paymentType": "Payment method",
  "delivery.accounts.add.stepRecap.serviceRecap.plan": "Plan",
  "delivery.accounts.add.stepRecap.serviceRecap.type": "Email type",
  "delivery.accounts.add.stepRecap.serviceRecap.volume": "Number of email messages",
  "delivery.accounts.add.stepRecap.title": "Summary",
  "delivery.accounts.button.addNew": "Account",
  "delivery.accounts.confirmationModal.deleteAccount.message":
    "You are tring to delete the account <code>{account}</code>",
  "delivery.accounts.confirmationModal.deleteAccount.title": "Delete account",
  "delivery.accounts.dashboard.activities.accepted": "Accepted",
  "delivery.accounts.dashboard.activities.bounces": "Bounced",
  "delivery.accounts.dashboard.activities.delivered": "Delivered",
  "delivery.accounts.dashboard.activities.desc": "Details of the activities related to sent messages.",
  "delivery.accounts.dashboard.activities.enqueued": "Enqueued",
  "delivery.accounts.dashboard.activities.remainingMessages": "Remaining messages",
  "delivery.accounts.dashboard.activities.suppressed": "Suppressed",
  "delivery.accounts.dashboard.activities.title": "Activities",
  "delivery.accounts.dashboard.details.desc": "Features of the plan activated for the account.",
  "delivery.accounts.dashboard.details.table.activationDate": "Active since",
  "delivery.accounts.dashboard.details.table.connectedDomains": "Connected domains",
  "delivery.accounts.dashboard.details.table.extraDelivery": "Extra email messages",
  "delivery.accounts.dashboard.details.table.lastRenewal": "Last renewal",
  "delivery.accounts.dashboard.details.table.nextRenewal": "Next renewal",
  "delivery.accounts.dashboard.details.table.planVolumes": "Email messages included in the plan",
  "delivery.accounts.dashboard.details.table.title": "Content",
  "delivery.accounts.dashboard.details.title": "Plan details",
  "delivery.accounts.detailsAndSecurity.bounceNotification.desc":
    "Bounce alerts are sent to the sender of the message by default. You can receive them at a different address by indicating it here.",
  "delivery.accounts.detailsAndSecurity.bounceNotification.label.custom": "Customize",
  "delivery.accounts.detailsAndSecurity.bounceNotification.label.toSender": "Message sender address",
  "delivery.accounts.detailsAndSecurity.bounceNotification.title": "Bounce notification",
  "delivery.accounts.detailsAndSecurity.credentials.desc":
    "Account credentials have to be entered into your email client to log in.",
  "delivery.accounts.detailsAndSecurity.credentials.title": "Credentials",
  "delivery.accounts.detailsAndSecurity.enabledIps.desc": "Limit the account's access to the IP addresses you trust.",
  "delivery.accounts.detailsAndSecurity.enabledIps.tableTitle": "Authorised IP addresses",
  "delivery.accounts.detailsAndSecurity.enabledIps.title": "Enabled IPs",
  "delivery.accounts.detailsAndSecurity.ignoreSuppressionList.desc":
    "Choose whether to ignore the suppression list when sending messages with this account.",
  "delivery.accounts.detailsAndSecurity.ignoreSuppressionList.hint":
    "By enabling this setting, messages will be sent even to email addresses present in the suppression list. The suppression list will continue to be populated.",
  "delivery.accounts.detailsAndSecurity.ignoreSuppressionList.title": "Suppression List",
  "delivery.accounts.detailsAndSecurity.newPassword.modal.desc":
    "Generating a new password will replace the existing one. Remember to update the password if you have placed it in applications that are connected to your account.<br/><br/>Once the new password is generated remember to <b>copy and save it</b> because you will not be able to visualize it later.",
  "delivery.accounts.detailsAndSecurity.newPassword.modal.title": "Confirm new password generation",
  "delivery.accounts.detailsAndSecurity.personalDescription.desc":
    "Add a short description that will help you to indentify this account.",
  "delivery.accounts.detailsAndSecurity.personalDescription.label": "Description",
  "delivery.accounts.detailsAndSecurity.personalDescription.title": "Personal description",
  "delivery.accounts.domains.connectedDomains.desc":
    "List of domains with which the account is authorized to send emails.",
  "delivery.accounts.domains.connectedDomains.exceededMsg": "Domains limit exceeded. You have {current} domains.",
  "delivery.accounts.domains.connectedDomains.modalLabel": "Selected domain",
  "delivery.accounts.domains.connectedDomains.modalMessage":
    "Select the domain you want to associate with the account. You can associate one domain at a time.",
  "delivery.accounts.domains.connectedDomains.title": "Account-domains association",
  "delivery.accounts.domains.connectedDomains.warningMsg": "Max of {domains} domains can be associated to this account",
  "delivery.accounts.domains.noAssociatedDomain.desc": "No domain associated with this account",
  "delivery.accounts.domains.noExistingDomain.desc":
    "You need to create a domain to be able to associate it with this account",
  "delivery.accounts.domains.noExistingDomain.msg": "Create a domain",
  "delivery.accounts.domainsPage.button.bindDomain": "Associate a domain",
  "delivery.accounts.emptyList.noRecordsMsg":
    "You need to create at least one Account and associate a domain to it to be able to send bulk emails.",
  "delivery.accounts.extradelivery.minimumOrder": "Minimum order 5 packages",
  "delivery.accounts.extradelivery.purchase": "1 package = 1,000 extra messages",
  "delivery.accounts.extradelivery.stepRecap.desc": "Below is the summary of the operation.",
  "delivery.accounts.extradelivery.stepRecap.table.title": "Extra email messages for the account",
  "delivery.accounts.extradelivery.stepRecap.title": "Summary and payment",
  "delivery.accounts.extradelivery.title": "Buy extra email packages",
  "delivery.accounts.freeTrial.warningMsg":
    "The free plan can be requested for only one account at a time. Each account can have the Free plan only once.",
  "delivery.accounts.label.availableMessages": "Available Messages",
  "delivery.accounts.label.customerName": "Customer",
  "delivery.accounts.label.deletingOn": "Scheduled for deletion",
  "delivery.accounts.label.domainsCount": "Associated domains",
  "delivery.accounts.label.expirationPrepaid": "Expiration",
  "delivery.accounts.label.extraDeliveries": "Extra email messages",
  "delivery.accounts.label.plan": "Plan",
  "delivery.accounts.label.remainingDeliveries": "Remaining email messages",
  "delivery.accounts.label.renewalDate": "Next renewal",
  "delivery.accounts.label.type": "Type",
  "delivery.accounts.label.waiting_payment": "Waiting for Payment",
  "delivery.accounts.list.title": "Managed Email Delivery Accounts",
  "delivery.accounts.listDesc":
    "Accounts are created when subscribing to an email sending plan. Every account has an username and a password, type and sending limits. Each account has one or more domains associated with it that are authorized to send. The service reputation is bound to the account.",
  "delivery.accounts.listTitle": "Accounts",
  "delivery.accounts.serviceManagement.changePlan.desc": "Change the account plan",
  "delivery.accounts.serviceManagement.changePlan.info":
    "You can change the active plan on the account by choosing from the Free, Monthly Subscription, or Prepaid Package options. The new plan will be active after payment is made. Until then, you can continue to use the current plan. When the new plan becomes active, any remaining unsent messages from the current plan will be lost.",
  "delivery.accounts.serviceManagement.changePlan.title": "Change plan",
  "delivery.accounts.serviceManagement.delete.desc": "Delete the account to end the service",
  "delivery.accounts.serviceManagement.delete.info":
    "To end the service you must delete the account. All the associated domains will not be deleted. The addresses in the suppression list which are connected to the account will be deleted: It is recommended to export the suppression list before proceeding with the deletion.",
  "delivery.accounts.serviceManagement.delete.title": "Close the service",
  "delivery.accounts.serviceManagement.restore.desc": "Restore the user before their definitive cancellation",
  "delivery.accounts.serviceManagement.restore.info":
    "It is possible to reactivate the monthly subscription before cancellation.<br/>Once the account has been deleted it will no longer be possible to restore it.",
  "delivery.accounts.serviceManagement.restore.title": "Restore the service",
  "delivery.accounts.show.detailInfo.type.promotional": "Promotional",
  "delivery.accounts.show.detailInfo.type.transactional": "Transactional",
  "delivery.accounts.show.pageLabel.username": "Username",
  "delivery.accounts.show.warning.noDomains.msg":
    "No domain associated. As long as you do not associate a domain, the account cannot send.",
  "delivery.accounts.update.stepPlanModification.change": "What will change",
  "delivery.accounts.update.stepPlanModification.desc": "Select a plan and the number of messages.",
  "delivery.accounts.update.stepPlanModification.desc.monthly":
    "If you change the number of messages included in the plan, you will lose the remaining ones for the current month.",
  "delivery.accounts.update.stepPlanModification.desc.prepaid": "Below is the summary of the order.",
  "delivery.accounts.update.stepPlanModification.expiration": "Expiration: ",
  "delivery.accounts.update.stepPlanModification.plan.title": "New plan",
  "delivery.accounts.update.stepPlanModification.title": "Subscribe to a different plan for the account",
  "delivery.accounts.update.stepPlanModification.title.monthly": "Modify monthly deliveries",
  "delivery.accounts.update.stepPlanModification.title.prepaid": "Purchase a new package",
  "delivery.accounts.update.stepRecap.desc": "Below is the summary of the order.",
  "delivery.accounts.update.stepRecap.modal.info.free":
    "The Free plan has been successfully activated for this account.",
  "delivery.accounts.update.stepRecap.modal.info.monthly":
    "You will receive an email with the summary of the order and a link to make the payment. The purchased product will be active as soon as we have recorded the payment. In the meantime, you can continue to use the current plan.",
  "delivery.accounts.update.stepRecap.modal.info.prepaid":
    "You will receive an email with the summary of the order and a link to make the payment. The purchased product will be available within 24 hours of receiving the payment.",
  "delivery.accounts.update.stepRecap.modal.title": "Order placed",
  "delivery.accounts.update.stepRecap.title": "Summary and Payment",
  "delivery.accounts.volumeManagement.desc": "Set the number of messages available for the account.",
  "delivery.accounts.volumeManagement.title": "Available messages",
  "delivery.accounts.volumes.monthly.10000": "10,000",
  "delivery.accounts.volumes.monthly.100000": "100,000",
  "delivery.accounts.volumes.monthly.250000": "250,000",
  "delivery.accounts.volumes.monthly.30000": "30,000",
  "delivery.accounts.volumes.monthly.5000": "5,000",
  "delivery.accounts.volumes.monthly.60000": "60,000",
  "delivery.accounts.volumes.more": "More then 250,000",
  "delivery.dashboardActivities.accepted": "Taken in charge",
  "delivery.dashboardActivities.bounces": "Bounced",
  "delivery.dashboardActivities.delivered": "Delivered",
  "delivery.dashboardActivities.enqueued": "Enqueued",
  "delivery.dashboardActivities.suppressed": "Suppressed",
  "delivery.dashboardActivities.unavailable": "Temporarily unavailable",
  "delivery.domains.accounts.connectedAccounts.desc":
    "List of accounts to which the domain is associated and for which it is authorized to send.",
  "delivery.domains.accounts.connectedAccounts.title": "Domain-accounts association",
  "delivery.domains.accounts.noAssociatedAccounts.desc": "No account associated with this domain",
  "delivery.domains.accounts.warningMessage": "To associate the domain to a new account, go to the Accounts section.",
  "delivery.domains.add.modal.message":
    "The domain has been created, to be able to use it you need to go through the <b>verification procedure</b>. <br/>Once verified, our systems will proceed automatically with the approval phase. <br/><b>REMINDER</b>: In order to be able to send with the domain, you must associate it with at least one account. ",
  "delivery.domains.add.step1.desc":
    "Add a domain to be associated with an account for sending transactional or promotional email.",
  "delivery.domains.add.step1.name.msg": "Specify the name of the domain:",
  "delivery.domains.add.step1.title": "Add a domain for sending messages",
  "delivery.domains.approval.approveAndActivate.warningMsg":
    "WARNING: After the approval is skipped, the domain will be able to send even without a correct DNS configuration.",
  "delivery.domains.approval.info.desc":
    "Check out the result of the approval procedure that is automatically executed.",
  "delivery.domains.approval.info.message.approved": "Domain approved",
  "delivery.domains.approval.info.message.needApproval":
    "The domain is waiting to be approved by our systems to send messages. You will receive an email with the response.",
  "delivery.domains.approval.info.message.notApproved":
    "The domain has failed our systems checks and has not been approved for sending messages for the following reason:",
  "delivery.domains.approval.info.message.pending": "Approval in progress",
  "delivery.domains.approval.info.title": "Approval for sending email",
  "delivery.domains.dns.fail": "",
  "delivery.domains.dns.success": "",
  "delivery.domains.list.desc":
    "Domains need to be added to the system and authorized to send emails. They must be associated to at least one account. Every domain has its own DKIM signature.",
  "delivery.domains.list.title": "Domains",
  "delivery.domains.show.label.active": "Active",
  "delivery.domains.show.label.inactive": "Disabled",
  "delivery.domains.show.warning.noAccounts.msg": "The domain is not associated with any account and cannot send.",
  "delivery.domains.status.approved": "Active",
  "delivery.domains.status.approved_dns": "Misconfigured DNS",
  "delivery.domains.status.disabled_by_admin": "Diabled by admin",
  "delivery.domains.status.disabled_by_customer": "Disabled by customer",
  "delivery.domains.status.need_approval": "Awaiting approval",
  "delivery.domains.status.not_verified": "Awaiting verification",
  "delivery.domains.status.pending_approval": "Approving",
  "delivery.domains.verification.notVerified": "Not verified",
  "delivery.domains.verification.send": "Send",
  "delivery.domains.verification.send.error": "Error sending email",
  "delivery.domains.verification.send.success": "Email sent successfully to {email}",
  "delivery.domains.verification.share_email": "Email address",
  "delivery.domains.verification.share_email_desc": "Send the configuration parameters to the email address you want.",
  "delivery.domains.verification.share_email_error": "Is not a valid email address",
  "delivery.domains.verification.share_params_download": "Or download them in .csv format",
  "delivery.domains.verification.spf_dkim.desc":
    "Enter these verification parameters in the DNS management panel of your domain and then click the button at the bottom of this page.",
  "delivery.domains.verification.spf_dkim.dkim.label": "DKIM Verification",
  "delivery.domains.verification.spf_dkim.dkim.warningMessage":
    "To ensure the security of the domain we require the configuration of two DKIM keys as CNAME records",
  "delivery.domains.verification.spf_dkim.dmarc.label": "DMARC verification",
  "delivery.domains.verification.spf_dkim.dmarc.warningMessage":
    "it is sufficient that a valid DMARC record is set on the domain. The following is an example.",
  "delivery.domains.verification.spf_dkim.shareRecords": "Share parameters",
  "delivery.domains.verification.spf_dkim.spf.label": "SPF Verification",
  "delivery.domains.verification.spf_dkim.spf.warningMessage":
    "it is sufficient that our <em>include</em> parameter is present in the SPF record of your domain. The following is an example.",
  "delivery.domains.verification.spf_dkim.title": "SPF and DKIM verification parameters",
  "delivery.domains.verification.verified": "Verified",
  "delivery.intro.betaBanner.description":
    "In the currently available Beta version, it is only possible to subscribe to the Free Trial plan with 5000 messages per month.",
  "delivery.intro.betaBanner.title": "THE SERVICE IS AVAILABLE IN FREE BETA VERSION",
  "delivery.intro.description":
    "Email Delivery is a dedicated service for sending large volumes of email messages via the SMTP protocol.<br />Send transactional and promotional emails without leaving your preferred sending application. Email Delivery is our SMTP engine that ensures the best possible deliverability.",
  "delivery.intro.title": "Email Delivery",
  "delivery.label.account": "Account",
  "delivery.maintenance.description": "The service is currently under maintenance. Please try again later.",
  "delivery.maintenance.title": "The Delivery Beta service is currently not available",
  "delivery.managedDomains.list.title": "Managed Email Delivery Domains",
  "delivery.manager.alert":
    "Once the operation is completed, the manager will be able to view, edit, and delete the selected account and all <b>its associated domains</b>.",
  "delivery.manager.alertDomains":
    "Once the operation is completed, the manager will be able to view, edit, and delete the selected domain and <b>all accounts</b> associated with it.",
  "delivery.manager.alertGeneric":
    "Once the operation is completed, the manager will be able to view, edit, and delete the selected account and <b>all these resources</b>.",
  "delivery.manager.confirmAccountAssign": "Do you want to assign the account {accountId} to this manager?",
  "delivery.manager.confirmDomainAssign": "Do you want to assign the domain {accountId} to this manager?",
  "delivery.manager.loadingLinkedResources": "Loading linked resources",
  "delivery.manager.noFreeResources": "No Email Delivery Accounts or Domains available for the manager.",
  "delivery.manager.pick.account": "Pick the account you want to assign to this manager.",
  "delivery.manager.pick.body": "To begin, select the type of resource you want to assign to the manager.",
  "delivery.manager.pick.button.account": "Assign Account",
  "delivery.manager.pick.button.domain": "Assign Domain",
  "delivery.manager.pick.domain": "Pick the domain you want to assign to this manager.",
  "delivery.manager.pick.title": "Do you want to assign an account or a domain?",
  "delivery.modal.extradeliveryOrder.cancel.content":
    "Do you confirm that you want to cancel the order placed for the purchase of extra email messages packages?",
  "delivery.modal.extradeliveryOrder.cancel.title": "Do you want to cancel the order?",
  "delivery.modal.planModification.cancel.content":
    "If you cancel the requested modification, the current plan will remain unchanged.",
  "delivery.modal.planModification.cancel.title": "Do you want to cancel the plan modification request?",
  "delivery.plan.free": "Free",
  "delivery.plan.monthly": "Monthly",
  "delivery.plan.prepaid": "Prepaid",
  "delivery.suppressionList.add.alert.success": "Email successfully added to the list",
  "delivery.suppressionList.add.desc":
    "Exclude an address from the recipients of emails you send by adding it to the suppression list. Indicate the reason for the exclusion and for which accounts it should be active.",
  "delivery.suppressionList.add.email.label": "Email address",
  "delivery.suppressionList.add.reason.bounce.label": "Bounce",
  "delivery.suppressionList.add.reason.complain.label": "Complaint",
  "delivery.suppressionList.add.reason.title": "Select the reason for the exclusion:",
  "delivery.suppressionList.add.restrictionRules.allAccountsToggle.label": "Block emails sent by all accounts",
  "delivery.suppressionList.add.restrictionRules.singleAccountToggle.label": "Block emails sent by specific accounts",
  "delivery.suppressionList.add.restrictionRules.title": "Email delivery restriction rules",
  "delivery.suppressionList.add.title": "Add an email address to the suppression list",
  "delivery.suppressionList.details.desc": "Consult and edit the restriction rules set for the e-mail address.",
  "delivery.suppressionList.details.title": "Restriction rules",
  "delivery.suppressionList.list.all": "All",
  "delivery.suppressionList.list.desc":
    "The email addresses that make up the suppression list are all the addresses that have generated a bounce or that have reported the communications received as spam (complaints). Addresses that have generated a bounce are automatically added to the list, complaints have to be entered manually.",
  "delivery.suppressionList.list.title": "Suppression List",
  "delivery.tracemail.contentTableItemLabel.accountId": "Account ID",
  "delivery.tracemail.contentTableItemLabel.country": "Country",
  "delivery.tracemail.contentTableItemLabel.deliveryDate": "Date",
  "delivery.tracemail.contentTableItemLabel.messageId": "Message ID",
  "delivery.tracemail.contentTableItemLabel.mxHost": "Relay",
  "delivery.tracemail.contentTableItemLabel.pool": "Sending Pool",
  "delivery.tracemail.contentTableItemLabel.recipient": "Recipient",
  "delivery.tracemail.contentTableItemLabel.relay": "Relay",
  "delivery.tracemail.contentTableItemLabel.response": "Response",
  "delivery.tracemail.contentTableItemLabel.sender": "Sender",
  "delivery.tracemail.contentTableItemLabel.senderIp": "Sender IP",
  "delivery.tracemail.contentTableItemLabel.size": "Size",
  "delivery.tracemail.contentTableItemLabel.smtpId": "SMTP ID",
  "delivery.tracemail.contentTableItemLabel.smtpResult": "Response",
  "delivery.tracemail.contentTableItemLabel.subject": "Subject",
  "delivery.tracemail.contentTableItemLabel.time": "Date",
  "delivery.tracemail.contentTableItemLabel.username": "Username",
  "delivery.tracemail.desc":
    "Tracemail allows real-time analysis of outgoing email traffic logs. Conduct a search by filling in the fields below, starting with the account.",
  "delivery.tracemail.message": "Message",
  "delivery.tracemail.result": "Total sent messages: ",
  "delivery.tracemail.result.all": "All",
  "delivery.tracemail.result.bounced": "Bounced",
  "delivery.tracemail.result.delivered": "Delivered",
  "delivery.tracemail.result.enqueued": "Enqueued",
  "delivery.tracemail.result.limits": "Limits",
  "delivery.tracemail.result.login": "Authentication",
  "delivery.tracemail.result.status.bounced": "Bounced",
  "delivery.tracemail.result.status.delivered": "Delivered",
  "delivery.tracemail.result.status.enqueued": "Enqueued",
  "delivery.tracemail.result.status.sent": "Sent",
  "delivery.tracemail.result.status.suppressed": "Suppressed",
  "delivery.tracemail.result.suppressed": "Suppressed",
  "delivery.volume.monthly": "{amount} / month",
  "delivery.waitlist.success": "Request sent successfully",
  "description.text.delegate.recoveryPassword":
    "An email will be sent to <code>{emailDelegate}</code> with the password recovery instructions.",
  "description.text.delegate.recoveryPassword.email":
    "An email was sent to <code>{emailDelegate}</code> with the password recovery instructions.",
  "description.text.disabledDKIM": "DKIM signature is not enabled on this domain",
  "description.text.enabledDKIM": "DKIM signature is active",
  "detail.status.disabled": "Disabled",
  "detail.status.enabled": "Enabled",
  "detail.status.updating": "Updating",
  "detailInfo.data.currentSession": "Current",
  "detailInfo.data.messages.viewDate.noLimits": "Without time limits",
  "detailInfo.data.never": "Never",
  "detailInfo.data.no": "No",
  "detailInfo.data.noExpiration": "Without expiration",
  "detailInfo.data.paymentType.bank": "Bank transfer",
  "detailInfo.data.paymentType.paypal": "PayPal or credit card",
  "detailInfo.data.paymentType.paypalAuto": "PayPal with automatic debit",
  "detailInfo.data.paymentType.stripe": "Credit card with automatic charge",
  "detailInfo.data.user.company": "Company",
  "detailInfo.data.user.privato": "Private user",
  "detailInfo.data.volume.monthly": "{amount} / month",
  "detailInfo.data.volume.prepaid": "{amount}",
  "detailInfo.data.year": "year",
  "detailInfo.data.years": "years",
  "detailInfo.data.yes": "Yes",
  "detailInfo.label.DKIM.domain": "DKIM domain",
  "detailInfo.label.DKIM.selector": "DKIM selector",
  "detailInfo.label.DNS": "DNS",
  "detailInfo.label.DSN": "DSN",
  "detailInfo.label.account": "Account",
  "detailInfo.label.account25": "Account 25GB",
  "detailInfo.label.account8": "Account 8GB",
  "detailInfo.label.action": "Action",
  "detailInfo.label.activeOnNewMboxes": "Active on new accounts",
  "detailInfo.label.address": "Address",
  "detailInfo.label.analisysTime": "Analysis time",
  "detailInfo.label.archive": "Archive",
  "detailInfo.label.archive.delegates": "Delegates",
  "detailInfo.label.archive.import": "Import date",
  "detailInfo.label.archive.messages": "Archived messages",
  "detailInfo.label.archive.quota": "Occupied space",
  "detailInfo.label.archive.start": "Storage start",
  "detailInfo.label.availableMessages": "Available messages",
  "detailInfo.label.billingCycle": "Payment frequency",
  "detailInfo.label.billingEmail": "Invoices will be sent to",
  "detailInfo.label.city": "City",
  "detailInfo.label.client": "Client",
  "detailInfo.label.code": "Code",
  "detailInfo.label.company": "Company",
  "detailInfo.label.connectedDomains": "Connected domains",
  "detailInfo.label.country": "Country",
  "detailInfo.label.created": "Created",
  "detailInfo.label.customerCode": "Customer Code",
  "detailInfo.label.date": "Date",
  "detailInfo.label.defaultQuota": "Default size",
  "detailInfo.label.delay": "Delay",
  "detailInfo.label.deliveryAccounts": "Email Delivery Accounts",
  "detailInfo.label.deliveryDomains": "Email Delivery Domains",
  "detailInfo.label.deliverytime": "Delivery time",
  "detailInfo.label.detail": "Detail",
  "detailInfo.label.domains": "Domains",
  "detailInfo.label.email": "Email",
  "detailInfo.label.emailAccounts25gb": "Account 25GB",
  "detailInfo.label.emailAccounts50gb": "Account 50GB",
  "detailInfo.label.emailAccounts8gb": "Account 8GB",
  "detailInfo.label.error.authentication": "Authentication err.",
  "detailInfo.label.expiration": "Expiry",
  "detailInfo.label.expirationDate": "Expiration",
  "detailInfo.label.file": "File",
  "detailInfo.label.filter": "Result",
  "detailInfo.label.filter.detail": "Result details",
  "detailInfo.label.firstName": "First name",
  "detailInfo.label.fiscalcode": "Fiscal Code",
  "detailInfo.label.fiscalcode2": "Fiscal Code [if different from VAT number]",
  "detailInfo.label.from": "Sender",
  "detailInfo.label.lastAccess": "Last access",
  "detailInfo.label.lastName": "Last name",
  "detailInfo.label.localIP": "Qboxmail IP",
  "detailInfo.label.login.date": "Login date",
  "detailInfo.label.login.error": "Login error",
  "detailInfo.label.logout.date": "Logout date",
  "detailInfo.label.manager": "Manager",
  "detailInfo.label.max.accounts25": "Max accounts 25GB limits",
  "detailInfo.label.max.accounts8": "Max accounts 8GB limits",
  "detailInfo.label.max.accountsSize": "Max accounts size",
  "detailInfo.label.max.archive": "Max archive limits",
  "detailInfo.label.max.domains": "Max domains limits",
  "detailInfo.label.messageID": "Message ID",
  "detailInfo.label.messages.rest": "Reset counter",
  "detailInfo.label.messages.sent": "Messages sent (24h)",
  "detailInfo.label.messages.viewDate": "View contents",
  "detailInfo.label.migration.first_execution": "First execution",
  "detailInfo.label.migration.second_execution": "Second execution",
  "detailInfo.label.msg.deleted": "Deleted messages",
  "detailInfo.label.msg.expunged": "Expunged messages",
  "detailInfo.label.msg.trashed": "Trashed messages",
  "detailInfo.label.name": "Name",
  "detailInfo.label.order.code": "Order code",
  "detailInfo.label.order.minimunAccount": "Accounts added for minimum order",
  "detailInfo.label.order.status": "Order status",
  "detailInfo.label.permissions": "Permissions",
  "detailInfo.label.phonenumber": "Phone",
  "detailInfo.label.plan": "Plan",
  "detailInfo.label.planVolumes": "Email messages included in the plan",
  "detailInfo.label.port": "Port",
  "detailInfo.label.postcode": "Postcode",
  "detailInfo.label.postmasterAccount": "Postmaster account",
  "detailInfo.label.private": "Private",
  "detailInfo.label.protocol": "Protocol",
  "detailInfo.label.quote": "Account quote",
  "detailInfo.label.reason": "Reason",
  "detailInfo.label.recipient.number": "Tot. recipients",
  "detailInfo.label.reject.code": "Error code",
  "detailInfo.label.reject.message": "Error",
  "detailInfo.label.relay": "Relay",
  "detailInfo.label.remainingMessages": "Remaining messages",
  "detailInfo.label.remoteIP": "User IP",
  "detailInfo.label.remoteServerHost": "Remote server host",
  "detailInfo.label.reputation": "Reputation",
  "detailInfo.label.reseller": "Rivenditore",
  "detailInfo.label.response": "Response",
  "detailInfo.label.search.results": "Search results",
  "detailInfo.label.selectedMboxes": "Selected email accounts",
  "detailInfo.label.server": "Hosting Server",
  "detailInfo.label.serverDelivery": "Server",
  "detailInfo.label.session": "Session",
  "detailInfo.label.size": "Size",
  "detailInfo.label.smtpID": "SMTP ID",
  "detailInfo.label.spam": "Antispam analysis",
  "detailInfo.label.state": "State",
  "detailInfo.label.storage": "Storage",
  "detailInfo.label.storageOnNew": "New",
  "detailInfo.label.subject": "Subject",
  "detailInfo.label.to": "Recipient",
  "detailInfo.label.totalPrice": "Total price",
  "detailInfo.label.traffic.in": "Traffic in",
  "detailInfo.label.traffic.out": "Traffic out",
  "detailInfo.label.type": "Type",
  "detailInfo.label.user": "Account",
  "detailInfo.label.user.geoArea": "Geographic area",
  "detailInfo.label.user.kind": "Customer kind",
  "detailInfo.label.user.reseller": "Reseller customer",
  "detailInfo.label.user.whmcs.invoiceId": "WHMCS first Invoice ID",
  "detailInfo.label.user.whmcs.orderId": "WHMCS Order id",
  "detailInfo.label.value": "Value",
  "detailInfo.label.vat": "VAT number",
  "detailInfo.lable.billing.email": "Email for sending invoices",
  "detailInfo.lable.paymentType": "Payment method",
  "domainAlert.goToDocs": "Show documentation",
  "domainAlert.goToDocsMsg": "Don't know MX parameters?",
  "domainAlias.add.desc":
    "The new alias domain will inherit all email accounts, email aliases and forward of the real domain connected to it.",
  "domainAlias.add.title": "New alias domain",
  "domains.add.desc.step1":
    "Choose the plan and related features with you want to activate the new domain and its email accounts.",
  "domains.add.desc.step2":
    "Enter the contact information of the domain, the default language and time zone. With the domain a postmaster will also be created automatically, set a password for this account.",
  "domains.add.desc.step3":
    "Set the number of accounts and archives that can be activated for the domain and their size.",
  "domains.add.desc.step4":
    "Set the services available for domain accounts. <b>The services vary according to the plan selected</b>.",
  "domains.add.desc.step5": "Set the default security policies for the domain and its accounts.",
  "domains.add.desc.step6": "Set the sensitivity level of the antispam filter for domain accounts.",
  "domains.add.title.step1": "Domain plan",
  "domains.add.title.step2": "Domain info",
  "domains.add.title.step3": "Domain limits",
  "domains.add.title.step4": "Domain services",
  "domains.add.title.step5": "Domain security",
  "domains.add.title.step6": "Domain options",
  "domains.list.header.dsc": "The domains contain all the email accounts and email aliases belonging to them.",
  "domains.list.header.title": "Domains",
  "domains.list.table.label.code": "Code",
  "domains.list.table.label.customer": "Customer",
  "domains.list.table.label.domain": "Domain",
  "domains.list.table.label.domainsAlias": "Domains alias",
  "domains.list.table.label.emailAccounts": "Email accounts",
  "domains.list.table.label.emailsAlias": "Emails alias",
  "domains.list.table.label.status": "Status",
  "domains.settings.title": "Domain settings",
  "domains.show.desc.aliasDomains":
    "Domains alias are domains linked to real domains that inherit all of their accounts: email, email alias and forward",
  "domains.show.desc.aliasEmailAccounts":
    "Email aliases are email addresses that forward received messages to one or more addresses indicated as recipients for the alias.",
  "domains.show.desc.emailAccounts":
    "Email accounts are email addresses whose messages, sent and received, are accessible via POP / IMAP / SMTP and Webmail.",
  "dropzone.invalidMIME": "Unsupported file type",
  "emailAccountAlias.add.desc":
    "The new email alias will forward all messages received to all the accounts indicated as recipients.",
  "emailAccountAlias.add.title": "New email alias",
  "emailAccounts.add.desc.step1":
    "Enter the name, contact information and password of the email account. Once you have created <b>you cannot rename an email account</b>.",
  "emailAccounts.add.desc.step2":
    "Set email account size and available services. <b>Size and services vary based on your plan and domain settings</b>.",
  "emailAccounts.add.desc.step3": "Set policies related to password management and access for the email account.",
  "emailAccounts.add.desc.step4": "Set additional options for the email account",
  "emailAccounts.add.title.step1": "New account",
  "emailAccounts.add.title.step2": "Account services",
  "emailAccounts.add.title.step3": "Account security",
  "emailAccounts.add.title.step4": "Account options",
  "errorMsg.accept": "You must agree to place order",
  "errorMsg.click.toVerify": "Click button to validate",
  "errorMsg.delegate.account": "The delegate must have one assigned at least one email account",
  "errorMsg.length.passowrd": "Password of at least 8 alphanumeric characters",
  "errorMsg.missing.field": "Missing field",
  "errorMsg.notAvailable.domains": "You have no domains available",
  "errorMsg.notMarch.passowrd": "Unmatched passwords",
  "errorMsg.notValid.URL": "Not valid URL",
  "errorMsg.notValid.account.description": "Invalid account description",
  "errorMsg.notValid.domain": "Not valid domain",
  "errorMsg.notValid.emailAddress": "Not valid email address",
  "errorMsg.notValid.ip": "Not valid IP address",
  "errorMsg.notValid.loginCredentials": "Not valid username or password",
  "errorMsg.notValid.number": "Must be a number",
  "errorMsg.notValid.recipientCode": "It must be a 7 alphanumeric code or a valid PEC email",
  "errorMsg.planRequired": "Please select a plan for the new domain",
  "errorMsg.required": "Required",
  "errorMsg.required.customization.field": "Customization must have at least one of logo, company or help desk URL",
  "errorMsg.select.account": "Select at least one email account",
  "errorMsg.select.customer": "Select a customer",
  "errorMsg.select.deliveryAccount": "Select at least one account",
  "errorMsg.select.domain": "Select at least one domain",
  "errorMsg.vaultFoldersError": "There was an error, please contact us.",
  "errors.invalid_email": "This is not a valid email address",
  "errors.not_empty": "Cannot be empty",
  "errorsMsg.required.customization.custom_label": "Custom label is mandatory to use the personalized link",
  "etlive.legend.error": "Error",
  "etlive.legend.success": "Success",
  "etlive.legend.title": "Legend",
  "etlive.legend.warn": "Warn",
  "etlive.list.header.dsc":
    "Tracemail allows real-time analysis of services access and incoming/outgoing email traffic logs.",
  "etlive.list.header.title": "Tracemail",
  "etlive.list.searchMsg.notFoundLog": "No logs found",
  "etlive.list.searchMsg.selectDomain": "Select the domain for which you wish to view the logs",
  "etlive.list.searchMsg.selectLog": "Select log type you want to see",
  "etlive.log.accordion.attachments": "Attachments",
  "etlive.log.accordion.deliveries": "Deliveries",
  "etlive.log.accordion.notification": "Notifications",
  "etlive.log.accordion.notification.deliveries": "Delivery notifications",
  "etlive.log.export": "PDF Report",
  "etlive.log.exportPDF": "PDF",
  "etlive.log.exporting": "Exporting",
  "etlive.log.exportingError": "There was a problem with PDF export. Contact us.",
  "etlive.log.locateMessage": "Locate message",
  "etlive.log.locateMessageLoading": "Searching...",
  "etlive.log.locateMessageShort": "Locate",
  "etlive.log.locatingError": "There was a problem locating the message. Contact us.",
  "etlive.log.locatingMessage":
    "The message delivered to <b>{recipient}</b> on <b>{delivered_at}</b> <br/> is located in:",
  "etlive.log.locatingMessageNotFound":
    "The message delivered to <b>{recipient}</b> on <b>{delivered_at}</b> <br/> <b>is no longer in the mailbox</b>. <br/> It may have been deleted or downloaded via POP protocol.",
  "etlive.log.title.accesss": "Access",
  "etlive.log.title.email.not.received": "Message rejected",
  "etlive.log.title.email.not.sent": "Message not sent",
  "etlive.log.title.email.received": "Received message",
  "etlive.log.title.email.sent": "Sent message",
  "feature.antimalware": "Antimalware Premium",
  "feature.antivirus": "Antivirus and Antispam",
  "feature.basic": "Basic plan features",
  "feature.exchange": "Microsoft® Exchange ActiveSync",
  "feature.mailServices": "POP, IMAP, SMTP",
  "feature.mailboxSize": "Mailboxes up to 25 GB",
  "feature.mailboxSize100": "Mailboxes up to 100 GB",
  "feature.mailboxSize50": "Mailboxes up to 50 GB",
  "feature.sharedCalendars": "Shared calendar and contacts",
  "feature.webmail": "Webmail",
  "folderMapper.label.accounts": "Accounts",
  "folderMapper.label.all.accounts": "All accounts",
  "folderMapper.label.all.folders": "All folders",
  "folderMapper.label.folders": "Folder",
  "folderMapper.label.full": "All",
  "folderMapper.label.ignore": "Ignore",
  "folderMapper.label.in": "In",
  "folderMapper.label.out": "Out",
  "folderMapper.label.subject": "Subject",
  "generals.requested.desc":
    "A support ticket has been opened to request a change to the daily sending limit for the account. <br/> <br/> You will soon receive an email with a link to the ticket where you will need to specify the limit you want to set.",
  "helpT.account.over8GB": "Email accounts bigger than 8GB cost more.",
  "helpT.add.emailAlias.destinations":
    "Assign a destination to the email alias you are creating and add it to the list. <code>You can assign up to 20 destinations per single email alias</code>.",
  "helpT.addArchive.step1": "You can only select domains with ownership verified and without archive already active.",
  "helpT.addDomain.domainName.step2":
    "The domain name must not contain <code>www.</code>, enter only name you want to see after <code>@</code>.",
  "helpT.addDomain.postmasterPassword.step2":
    "Enter a password for the user <code>postmaster@DOMAIN</code>. This user can manager all domains accounts.",
  "helpT.addEmailAccounts.emailAccountsName.step1":
    "If it is not a personal email account, enter a description of the account in the <code>User first name</code> field.",
  "helpT.order.company.noVat":
    "If your company has a Company Registration Number, but not a VAT number, enter <code>NOVATID</code>.<br/>You will then have to tell us this ID number for verification.",
  "helpT.order.company.referent": "Enter the name of the contact person or company legal representative.",
  "helpT.order.domain.add":
    "The domain name must not contain <code>www.</code>, enter only name you want to see after <code>@</code>.<br/>Once the order is complete you can add it to the list of your domains.",
  "helpT.order.domain.exist":
    "It is not possible to change the domain name as it is already present in your domain list. <br/> Once you have completed the order you can continue to manage it.",
  "helpT.order.plan.basic.desc": "For professionals or companies that want a convenient and quality service.",
  "helpT.order.plan.basic.title": "Basic",
  "helpT.order.plan.enterprise.desc":
    "For organizations that require advanced communication tools for their employees and high security in the use of services.",
  "helpT.order.plan.enterprise.title": "Enterprise",
  "helpT.order.plan.professional.desc":
    "For companies that need to coordinate and communicate with all their employees in a simple and intuitive way.",
  "helpT.order.plan.professional.title": "Professional",
  "imports.add.desc":
    "Create the .CSV file with the necessary information and import domains, domains alias, email accounts and email alias.",
  "imports.add.title": "New import",
  "imports.list.header.dsc":
    "The Imports allow to insert in the panel domains, domains alias, email accounts and email alias through a .CSV file.",
  "imports.list.header.title": "Imports",
  "imports.resources.header.alias_domain": "Alias domain",
  "imports.resources.header.destinations": "Destinations",
  "imports.resources.header.firstname": "Firstname",
  "imports.resources.header.forwards": "Forwards",
  "imports.resources.header.lastname": "Lastname",
  "imports.resources.header.manager_code": "Manager code",
  "imports.resources.header.password_type": "Imported password format",
  "imports.resources.header.postmaster_password": "Imported postmaster password format",
  "imports.resources.header.title": "Import",
  "imports.resources.passwordType.hash": "Hash",
  "imports.resources.passwordType.plain": "Plain",
  included: "included",
  "infoMsg.DKIMInstruction": "Insert this TXT record in the DNS configuration panel of the domain",
  "infoMsg.OTP.disabled": "OTP authentication is not enabled on this account.",
  "infoMsg.account.updating": "Account settings being updated",
  "infoMsg.advancedContactInfo":
    "This information will be displayed in the Organization contacts. Advanced contact info is <b>only available for Professional and Enterprise plans</b>. Update your domain plan to enable these forms.",
  "infoMsg.annualSendingLimit": "To increase your daily sending limit, open a support ticket",
  "infoMsg.apiUsage.disabled": "Api usage is disabled for this account",
  "infoMsg.archiveAlready": "Archive already active",
  "infoMsg.billing":
    "The credentials to access the management panel of your domains will in any case be independent of those to access the billing area.",
  "infoMsg.billing.system":
    "Your billing system login credentials are:<br/><br/>Username: <code>{userName}</code><br/>Password: <code>Control panel password</code><br/><br/>Use these credentials to access the billing system through the link you will receive via email or choose another email address and password to access.",
  "infoMsg.canInfluenceBilling": "Can affect billing",
  "infoMsg.catchAllDisabled": "You can't enable catch all right now, please contact us",
  "infoMsg.catchAllDisabledAdmin": "Customer has catch all disabled, enabled to edit it here",
  "infoMsg.code.newGeneration": "New code generation",
  "infoMsg.confirmed.emailAddress": "Email address confirmed successfully",
  "infoMsg.delivery.pendingExtradeliveryOrder":
    "An order for the purchase of extra email messages packages has been placed. The messages will be available within 24 hours of receiving the payment.",
  "infoMsg.delivery.pendingUpdateOrder.modification":
    "A plan modification has been requested. The modification will be applied within 24 hours of receiving the payment.",
  "infoMsg.delivery.pendingUpdateOrder.purchase":
    "An order for the purchase of another delivery package has been placed. The messages will be available within 24 hours of receiving the payment.",
  "infoMsg.delivery.selectAccountFirst": "First, select the account",
  "infoMsg.delivery.unhealthy.desc": "Check your configuration to ensure emails are delivered.",
  "infoMsg.delivery.unhealthy.text": "DNS configuration for domain is not correct.",
  "infoMsg.disabled.inTtrial": "Change not available for trial users",
  "infoMsg.disabledWhileWaitPaid": "The sending limit cannot be changed during the trial period.",
  "infoMsg.domainUpdating": "Domain is updating, you will be able to modify it as soon as it will finish",
  "infoMsg.downgradeEmails": "To remove accounts from the domain contact customer support",
  "infoMsg.downgradePlan": "To downgrade the plan, contact customer support",
  "infoMsg.etliveUnavailable.msg": "Tracemail is unavailable at the moment. Retry later.",
  "infoMsg.expertModeOnlyReseller": "advanced CSV is available only for resellers",
  "infoMsg.invoice.monthly": "Complete the order and you can then activate all the email accounts you need.",
  "infoMsg.linkedToAccount": "Linked to account: {acc}",
  "infoMsg.linkedToDomain": "Linked to domain: {dom}",
  "infoMsg.loading.accounts": "Email accounts loading",
  "infoMsg.loading.limits": "Loading sending limits...",
  "infoMsg.loadingMboxes": "Loading email accounts",
  "infoMsg.managerInvolvedDeliveryDomains":
    "The manager will also have management permissions for the associated domains: <b>{involvedDomains}</b>",
  "infoMsg.manualLimits": "Or set limits manually",
  "infoMsg.maxDomainQuota": "This cannot exceed the domain's max email quota, that is ",
  "infoMsg.maxQuota": "A different maximum size from the default ones does not entail a cost reduction.",
  "infoMsg.noCustomizations.available.desc":
    "All your domains with professional or enterprise plan have a customization already. Delete one of the existing customizations to create a new one.",
  "infoMsg.noCustomizations.available.msg": "You have no domains to customize",
  "infoMsg.noDataAvailableYet.msg": "No data available yet",
  "infoMsg.noDomsSelected": "The domain has no email account, you need at least one account to activate the archive",
  "infoMsg.noElements": "No elements",
  "infoMsg.noMoreLogs": "There are no other logs",
  "infoMsg.noOrder": "No order made",
  "infoMsg.noRecords.desc": "The search did not produce results, try again using different criteria.",
  "infoMsg.noRecords.msg": "No element found",
  "infoMsg.noVat": "VAT excluded",
  "infoMsg.not.achive.domain": "There are no accounts with active archive for this domain.",
  "infoMsg.notFoundURL.desc": "The page you are looking for is not available, do not lose hope!",
  "infoMsg.notFoundURL.msg": "This page does not exist",
  "infoMsg.order.annual":
    "To complete the procedure it is necessary to order at least 5 email accounts that can be dismantled even on multiple domains. All prices are VAT excluded.",
  "infoMsg.order.domain.notInfo": "Complete information for all domains.",
  "infoMsg.order.minimum.annual":
    "You must enter <b>at least 5 email accounts</b>, even on different domains, to place the order.",
  "infoMsg.order.minimum.annual.domain":
    "You must enter at least <b>1 domain</b> and <b>5 email accounts</b> to place the order.",
  "infoMsg.order.minimum.monthly":
    "Minimum order 5 email accounts. We will <b>add {accountNumber} accounts</b> to your order which you can activate as soon as the procedure is completed.",
  "infoMsg.order.monthly": "Once the order is complete you can activate all the domains and email accounts you need.",
  "infoMsg.otp.cantDisable": "You can't disable two factor authentication on this account",
  "infoMsg.owCheckHTML.failed": "Verification failed",
  "infoMsg.passwordReset.disabled": "Password reset is disabled on this account",
  "infoMsg.payOption": "Paid option",
  "infoMsg.payOption.invoice": "Saving this setting will impact on your invoice",
  "infoMsg.planAlert.noBasic": "These features are <b>only available for Professional and Enterprise plans</b>.",
  "infoMsg.planAlert.noProfessional": "These features are <b>only available for Enterprise plan</b>.",
  "infoMsg.priceVat": "All prices are <b>VAT excluded</b>.",
  "infoMsg.requestSent": "A request was sent on {date} at {time}. You can send another request after 24 hours.",
  "infoMsg.resetPwdForced": "User must update the password on next login",
  "infoMsg.resetPwdForcedAll": "Users must update the password on next login",
  "infoMsg.sanityCheck.failed": "Something went wrong, contact us",
  "infoMsg.selectDomainFirst": "Select a domain first",
  "infoMsg.token.copied": "Copied token code",
  "infoMsg.trial.customer":
    "You are in the trial period, you cannot activate more than 5 domains and 25 email accounts",
  "infoMsg.trialAdvancedSettings": "You can change the advanced settings when you have completed an order",
  "infoMsg.unhealthy.desc":
    "If you have already done the update, ignore this warning. It will disappear automatically within 24 hours.",
  "infoMsg.unhealthy.text": "Domain active. Update or verify MX records.",
  "infoMsg.unsaveChanged": "Save your changes or they will be lost",
  "infoMsg.validation.domain.inPorgress": "Domains validation in progress...",
  "infoMsg.verifingOwnershipCheck":
    "We are verifing the DNS record. It could take up to 24 hours until the new configuration will work",
  "infoMsg.verify.emailAddress": "Verify your email address first. (Click on the link in the email we sent you)",
  "infoMsg.webmail.signature.account.planAlert":
    "The signatures management from the Control Panel is <b>only available for Professional and Enterprise plans</b>.",
  "infoMsg.webmail.signature.domain.planAlert":
    "Centralized signature management is <b>only available for Professional and Enterprise plans</b>.",
  "input.error.empity": "Fill in the field",
  "input.error.notValid.domain": "Not valid domain",
  "input.error.pwdMatch": "No match password",
  "input.hint.account.size":
    "The maximum size of the account can't be greater than the one set for the corresponding domain. <code>Max size set: {maxSize}</code>",
  "input.hint.activeNow": "Currently active: <b>{resourcesCustomer}</b>",
  "input.hint.activeNowFull":
    "Currently active: <b>{total}</b> (<b>{gb8}</b> 8GB, <b>{gb25}</b> 25GB,  <b>{postmaster}</b> postmaster only domains)",
  "input.hint.archive.retention":
    "The storage duration is calculated starting from the date of receipt / sending of each single message. Messages whose date exceeds the chosen storage period will be automatically deleted from the archive.",
  "input.hint.autoresponder": "Can't be activated when bounce is enabled.",
  "input.hint.billing.annually":
    "Allows you to activate a fixed number of email boxes that remains unchanged for one year. [Not available for resellers]",
  "input.hint.billing.monthly":
    "Allows for maximum flexibility in managing email boxes: you can create, modify, and delete the boxes at any time. The monthly fee will be automatically adjusted. Minimum order 5 boxes.",
  "input.hint.customization.company": "Enter the name of the company you want to appear on the page title",
  "input.hint.customization.customUrl1": "Use this field to create a custom link to show in the webmail's login page.",
  "input.hint.customization.helpDeskUrl":
    "Insert the link to your customer support that will appear in the sidebar of the control panel. The link must start with http:// or https://",
  "input.hint.customization.recoverPasswordUrl1":
    "Customize the url used to recover your user password. This url will be on the webmail's login page.",
  "input.hint.customization.upload.logo": "Supported formats: JPG / JPEG / PNG max size 480 x 96 pixels. Or SVG.",
  "input.hint.default.option": "Default option",
  "input.hint.disabled.autoresponderOrForwards":
    "Can't be activated when there are forwards, autoresponder or spam delivery in inbox is active",
  "input.hint.disabled.bounce": "Can't be activated when bounce is enabled",
  "input.hint.disabled.onDomain": "Disabled on domain",
  "input.hint.discontinued": "Being phased out",
  "input.hint.included": "Included in the plan",
  "input.hint.managerAssignedNow": "Now assigned: <b>{tot}</b>",
  "input.hint.migration.executeNow": "With this option the first round will start within 15 mintues",
  "input.hint.paid.option": "Paid option",
  "input.hint.passwordScore.check": "Password strength",
  "input.hint.passwordScore.easy": "Very weak password",
  "input.hint.passwordScore.great": "Great password!",
  "input.hint.passwordScore.poor": "Too weak password",
  "input.hint.passwordScore.strong": "Strong password",
  "input.hint.passwordScore.weak": "Weak password",
  "input.hint.remembered.devices":
    "Devices on which the OTP code will not be requested.<br/>When one of the devices is removed from the list, the OTP code will be requested again at the next access.",
  "input.hint.ticket.object": "Describe the problem in detail.",
  "input.label.access.active_sync": "Enable Microsoft® Exchange ActiveSync",
  "input.label.access.chat": "Enable Chat",
  "input.label.access.dav": "Enable DAV",
  "input.label.access.imap": "Access IMAP connection",
  "input.label.access.meeting": "Enable Meeting",
  "input.label.access.pop": "Access POP connection",
  "input.label.access.smtp": "Access SMTP connection",
  "input.label.access.webmail": "Access Webmail",
  "input.label.account": "Account",
  "input.label.account.limits.sending": "Account sending limits",
  "input.label.account.size": "Account size",
  "input.label.accountsDefaultQuota": "Default size new accounts",
  "input.label.action": "Action",
  "input.label.add.alias": "Add alias address",
  "input.label.add.destination": "Add destination",
  "input.label.add.ipAddress": "Add IP address",
  "input.label.add.ipRestrictions": "Add IP restrictions",
  "input.label.add.sender.bcc": "Add sender in Bcc",
  "input.label.add.signature.replies": "Don't add signature on replies",
  "input.label.address": "Address",
  "input.label.advanced.csv": "Upload advanced .CSV file",
  "input.label.antimalware_premium": "Enable Antimalware and Antivirus Premium",
  "input.label.antispam.level.absent": "Absent",
  "input.label.antispam.level.aggressive": "Aggressive",
  "input.label.antispam.level.default": "Set default antispam level for domain accounts",
  "input.label.antispam.level.standard": "Standard",
  "input.label.antispam.level.tolerant": "Tolerant",
  "input.label.api_enabled": "Enable API access",
  "input.label.applyDefaultQuotaToAll": "Apply password settings to all accounts retroactively",
  "input.label.applyPwdPoliciesToAll": "Apply all password settings to all existing email accounts of the domain",
  "input.label.apply_allow_nets_webmail": "Apply IP restriction also to webmail",
  "input.label.archive.available": "Archives available",
  "input.label.archiveOnNew": "Active on new email accounts",
  "input.label.audit.action": "Action",
  "input.label.audit.includeQueryAudits": "Include audits queries in results",
  "input.label.audit.medium": "Medium",
  "input.label.audit.target": "Subject",
  "input.label.audit.viewAs": "View as",
  "input.label.audit.who": "Author",
  "input.label.authorization.expiration": "Authorization expiry",
  "input.label.authorization.noExpiration": "Authorization without expiration",
  "input.label.billing.annually": "Annual",
  "input.label.billing.cycle": "Billing",
  "input.label.billing.email": "Email for billing area",
  "input.label.billing.extraContact": "Add extra contact to receive invoices (optional)",
  "input.label.billing.extraContactEmail": "Email",
  "input.label.billing.extraContactFirstname": "First name",
  "input.label.billing.extraContactLastname": "Last name",
  "input.label.billing.monthly": "Monthly",
  "input.label.billing.password": "Password for billing area",
  "input.label.billing.password.confirm": "Confirm billing area password",
  "input.label.billing.system": "Billing area",
  "input.label.billing.system.otherCredentials": "Use other credentials to access the billing area",
  "input.label.block_old_pwd": "Block old password reuse",
  "input.label.bounceMsg": "Bounce message",
  "input.label.callbackURL": "Callback URL",
  "input.label.can.haveCatchAll": "Customer can have catch all",
  "input.label.canEditOutboundLimits": "Customer can edit outbound limits",
  "input.label.catchAll.address": "Catch all address",
  "input.label.catchAll.enable": "Enable catch all address",
  "input.label.city": "City",
  "input.label.company": "Company",
  "input.label.company.delegate": "Delegate company",
  "input.label.country": "Country",
  "input.label.customer": "Customer",
  "input.label.customerAreaEmail": "Customer Area Email",
  "input.label.customerAreaPassword": "Customer Area Password",
  "input.label.customerAreaPassword.confirm": "Confirm Customer Area Password",
  "input.label.customization.customUrl1": "Customized link (#3)",
  "input.label.customization.custom_url": "Panel Custom URL",
  "input.label.customization.custom_url.mtm": "Mail Time Machine custom URL",
  "input.label.customization.custom_url.vault": "Vault custom URL",
  "input.label.customization.custom_url.webmail": "Webmail custom URL",
  "input.label.customization.domains": "Domains that will see this theme",
  "input.label.customization.helpDeskUrl": "Help desk URL for customers (#1)",
  "input.label.customization.preview": "Webmail customization preview",
  "input.label.customization.recoverPasswordUrl1": "Recovery password link (#2)",
  "input.label.customization.upload.logo": "Upload logo",
  "input.label.date.end": "End date",
  "input.label.date.expiration": "Expiration date",
  "input.label.date.from": "From date",
  "input.label.date.onDay": "On day",
  "input.label.date.start": "Start date",
  "input.label.date.to": "To date",
  "input.label.dateFormats": "Date format",
  "input.label.default.identity": "Set as default identity",
  "input.label.delivery.tracemail.dateRange": "Date Range",
  "input.label.description": "Description",
  "input.label.destroy_sessions_on_password_expiration": "Force logout and disable all services on expiration",
  "input.label.disable_pwd_change": "Disable password change",
  "input.label.disable_pwd_recovery": "Disable password recovery",
  "input.label.display.name": "Display name",
  "input.label.distributor_id": "Distributor ID",
  "input.label.domain": "Domain",
  "input.label.domain.company": "Company name",
  "input.label.domain.creationNotification": "Notify when domain is created",
  "input.label.domain.limits.sending": "Default sending limits for all domain accounts",
  "input.label.domain.name": "Domain name",
  "input.label.domain.telephone": "Company telephone",
  "input.label.domainAlias.name": "Domain alias name",
  "input.label.domainsAvailable": "Available domains",
  "input.label.domainsManager": "Assign domains to manager",
  "input.label.domainsSelected": "Selected domains",
  "input.label.dragHere": "Drag a file or click here to upload it",
  "input.label.email": "Email",
  "input.label.email.fax": "Fax",
  "input.label.email.mobilephone": "Mobile phone",
  "input.label.email.notification": "Email address where notifications will be sent",
  "input.label.email.organizational_unit": "Organizational unit",
  "input.label.email.role": "Role",
  "input.label.email.secondaryEmail": "Secondary email address",
  "input.label.email.teamManager": "Team manager",
  "input.label.enableAutoresponder": "Enable autoresponder",
  "input.label.enableBounceMsg": "Enable bounce message",
  "input.label.enableIntervals": "Enable time interval",
  "input.label.filterBy": "Filter by",
  "input.label.firstName": "First name",
  "input.label.firstName.user": "First name",
  "input.label.fiscalcode": "Fiscal Code",
  "input.label.fiscalcode2": "Fiscal Code [if different from VAT number]",
  "input.label.force_otp": "Force use of two factor authentication",
  "input.label.force_password_first_login": "Force password change on first login",
  "input.label.forward.add": "Add forward address",
  "input.label.generateNewPassword": "Generate a new password and replace the existing one",
  "input.label.hide_from_addressbook_company": "Hide users from company addressbook",
  "input.label.hide_from_addressbook_company_user": "Hide user from company addressbook",
  "input.label.hostname": "Hostname",
  "input.label.hours.from": "From",
  "input.label.hours.to": "To",
  "input.label.ignoreSuppressionList": "Ignore suppression list",
  "input.label.import.selectFile": "Select file to import",
  "input.label.import.type": "Import type",
  "input.label.ip.restrictionsToAll": "Apply IP restrictions to all domain accounts",
  "input.label.ip.restrictionsToWebmail": "Apply IP restrictions also to the webmail",
  "input.label.is.reseller": "Reseller customer",
  "input.label.is.wholesale": "Wholesale customer",
  "input.label.keepCopy": "Keep messages copy in the server",
  "input.label.language": "Language",
  "input.label.lastDays": "Last",
  "input.label.lastName": "Last name",
  "input.label.lastName.user": "Last name",
  "input.label.login.remeber": "Remember this device for 30 days",
  "input.label.maxAccountsAvailable100": "Max accounts 100GB available",
  "input.label.maxAccountsAvailable25": "Max accounts 25GB available",
  "input.label.maxAccountsAvailable50": "Max accounts 50GB available",
  "input.label.maxAccountsAvailable8": "Max accounts available",
  "input.label.maxAccountsSize": "Max accounts size",
  "input.label.maxArchiveAvailable": "Max archives available",
  "input.label.maxDeliveryFree": "Max number of Delivery free accounts",
  "input.label.maxDomainsAvailable": "Max domains available",
  "input.label.maxNewDeliveryAccountsAvailable": "Max new accounts for sending",
  "input.label.maxNewDeliveryDomainsAvailable": "Max new domains for sending",
  "input.label.message.body": "Message text",
  "input.label.message.subject": "Message subject",
  "input.label.migration.executeNow": "Execute first round as soon as possible",
  "input.label.migration.masteruser": "Migration with Masteruser",
  "input.label.migration.secondExecHour": "Execute second round after",
  "input.label.migration.selectFile": "Select file to migrate",
  "input.label.migration.startDate": "Migration start date",
  "input.label.mx1": "MX 1",
  "input.label.mx2": "MX 2",
  "input.label.otpCode": "Enter code generated by the application",
  "input.label.override_plan_num_messages": "Maintain this value ({value}) even in future renewals.",
  "input.label.password": "Password",
  "input.label.password.forceChange.nextLogin": "Force new password on next login",
  "input.label.password.forceChange.nextLogin.domain": "Force new password on next login for domains emails accounts",
  "input.label.password.new": "New password",
  "input.label.password.old": "Old password",
  "input.label.password.postmaster": "Postmaster password",
  "input.label.passwordConfirm": "Confirm password",
  "input.label.passwordConfirm.new": "Confirm new password",
  "input.label.passwordConfirm.postmaster": "Confirm postmaster password",
  "input.label.password_expiration_counter_start": "The counter of {months} months will start from today",
  "input.label.personalData": "Appointment contract of Qboxmail Srl to Data processor",
  "input.label.postcode": "Zip code",
  "input.label.privacy": "Privacy Policy",
  "input.label.promocode": "Promo code",
  "input.label.protocol": "Access protocol",
  "input.label.pwd_expiration": "Set password expiration for all domain accounts",
  "input.label.pwd_expiration.12": "12 months",
  "input.label.pwd_expiration.3": "3 months",
  "input.label.pwd_expiration.6": "6 months",
  "input.label.pwd_expiration.never": "Never",
  "input.label.pwd_expiration_email": "Set email account password expiration",
  "input.label.quotaExceeded": "Notify when account is near to max quota",
  "input.label.quoteSelector.included": "Included in plan",
  "input.label.quoteSelector.upgradeL": "Upgrade Large",
  "input.label.quoteSelector.upgradeM": "Upgrade Medium",
  "input.label.quoteSelector.upgradeXL": "Upgrade XL",
  "input.label.recipient": "Recipient",
  "input.label.recipientCode": "Recipient code for electronic invoicing",
  "input.label.remembered.devices": "Remembered devices",
  "input.label.restore_plan_num_messages": "Restore the default plan value ({value})",
  "input.label.retention": "Select retention years",
  "input.label.select.country": "Country in which the organization is based",
  "input.label.select.countryEmail": "Country in which the user operates",
  "input.label.select.identity": "Select identity",
  "input.label.select.payment.frequency": "Select the payment frequency",
  "input.label.select.payment.method": "Select payment method",
  "input.label.select.plan": "Select plan",
  "input.label.select.usert.type": "Select the user type that represents you",
  "input.label.select.verificationEmail": "Choose where to receive verification code",
  "input.label.selectAll": "Select all",
  "input.label.selectMboxes": "Select accounts email",
  "input.label.sender": "Sender",
  "input.label.sentLimits": "Account sending limits",
  "input.label.sentLimits.defautl": "Default sending limits for all accounts in the domain",
  "input.label.sentMsg24h": "{msgNumber} messages every {hours} hours {option}",
  "input.label.sentMsg24h.domainDefault": "Sending limits as the domain {option}",
  "input.label.serverSource": "Select source server type",
  "input.label.signature.apply.toAll": "Add signature to all domain email accounts",
  "input.label.signature.apply.toNew": "Automatically add signature to all new email accounts",
  "input.label.signature.apply.toWhitout": "Add signature to all email accounts that don't yet have one",
  "input.label.signature.text": "Signature text",
  "input.label.spamInInbox": "Deliver spam in Inbox",
  "input.label.state": "State",
  "input.label.telephone": "Phone number",
  "input.label.terms": "Contractual terms and conditions relating to the Qboxmail Service",
  "input.label.timeFormats": "Time format",
  "input.label.timezone": "Time zone",
  "input.label.tracemail21DaysLimit": "Limit visibility of logs to 21 days",
  "input.label.tracemail21DaysLimitDefault": "Limit log visibility to 21 days for all new domains",
  "input.label.username": "Username",
  "input.label.vat": "VAT number",
  "input.label.verify.code": "Verify code",
  "input.label.visualization.always": "View archive content without time limits",
  "input.label.visualization.end": "View contents up to day",
  "input.label.visualization.start": "View contents from day",
  "input.label.volume": "Available messages",
  "input.label.whmcs_id": "ID WHMCS",
  "input.placeholder.Loading": "Loading...",
  "input.placeholder.account.select": "Select account",
  "input.placeholder.address": "Address",
  "input.placeholder.audit.searchMsg": "Enter the first 4 letters of an email account or user code",
  "input.placeholder.audit.viewAs": "Search account o ID",
  "input.placeholder.city": "City",
  "input.placeholder.company": "Company name",
  "input.placeholder.country": "Country",
  "input.placeholder.customerSelect": "Customer name or code",
  "input.placeholder.delivery.description": "Description",
  "input.placeholder.delivery.tracemail.account": "Account name or account ID",
  "input.placeholder.delivery.tracemail.messageSubject": "Message subject",
  "input.placeholder.delivery.tracemail.recipient": "Recipient",
  "input.placeholder.delivery.tracemail.sender": "Sender",
  "input.placeholder.domain.hint": "Start typing domain's name or code to search it..",
  "input.placeholder.domain.name": "domain.com",
  "input.placeholder.domain.notFound": "No domain found",
  "input.placeholder.domain.select": "Select domain",
  "input.placeholder.domainCustomer": "Domain name o customer code",
  "input.placeholder.email": "Email address",
  "input.placeholder.email.hint": "First select a domain to see its email accounts list",
  "input.placeholder.fax": "Fax",
  "input.placeholder.filters": "Search",
  "input.placeholder.firstName": "First name",
  "input.placeholder.fiscalcode": "Fiscal Code",
  "input.placeholder.helpDeskUrl.label": "e.g. Click here to...",
  "input.placeholder.id": "ID",
  "input.placeholder.ip": "e.g. 192.123.12.32",
  "input.placeholder.lastName": "Last name",
  "input.placeholder.message.subject": "Subject",
  "input.placeholder.mobilephone": "Mobile phone",
  "input.placeholder.myOtherEmail": "myotheremail@domain.com",
  "input.placeholder.noFoundCustomers": "No customer found",
  "input.placeholder.noMatchess": "No matches for: ",
  "input.placeholder.organizational_unit": "Organizational unit",
  "input.placeholder.password": "Password",
  "input.placeholder.postcode": "ZIP code",
  "input.placeholder.promocode": "Promo code",
  "input.placeholder.pwdRules": "8+ alpha-numeric characters",
  "input.placeholder.recipientCode": "Numeric code or PEC email",
  "input.placeholder.role": "Role",
  "input.placeholder.state": "State",
  "input.placeholder.status": "Status",
  "input.placeholder.telephone": "Phone number",
  "input.placeholder.token.generating": "Generating token...",
  "input.placeholder.token.generation": "Generating the token...",
  "input.placeholder.token.reset": "Resetting...",
  "input.placeholder.url": "https://...",
  "input.placeholder.url_callback": "https://yoursite.com/callbackme",
  "input.placeholder.username": "Email or User ID",
  "input.placeholder.vat": "VAT ID",
  "label.billing.monthly": "Monthly charge",
  "label.billing.prepaid": "Total",
  "label.billing.resellerPrice": "Price for Resellers",
  "label.password": "Password",
  "label.username": "Username",
  "listTable.header.title.accounts.active": "Active accounts",
  "listTable.header.title.alias": "Alias addresses",
  "listTable.header.title.browser": "Browser",
  "listTable.header.title.destinations": "Destinations",
  "listTable.header.title.forwards": "Forward addresses",
  "listTable.header.title.ip": "IP / record",
  "listTable.header.title.ipEnabled": "IP addresses enabled for access",
  "listTable.header.title.name": "Name",
  "listTable.header.title.platform": "Platform",
  "listTable.header.title.signature.displayName": "Display name",
  "listTable.header.title.signature.identity": "identity",
  "listTable.header.title.type": "Type",
  "listTable.placeholder": "Add item to the list",
  "listTable.placeholder.signature": "Add your first identity",
  "loading.msg.data": "Loading data",
  "loading.msg.token": "Verify token validity",
  "login.footer.cookiePolicy": "Cookie Policy",
  "login.footer.privacyPolicy": "Privacy Policy",
  "login.footer.version": "Version",
  "login.screen.desc": "Organise your company's mailboxes",
  "login.screen.title": "Control Panel",
  "mailbox.intro.description":
    "In a single console you can find tools for creating, managing, and analysing mailboxes in total autonomy.<br />Import and manage all your users' mailboxes even across multiple domains.<br />Create specific roles for your employees and customers, assigning privileges and limits.<br />Monitor activities through specific analysis and reporting tools.",
  "mailbox.intro.title": "Email Hosting",
  "managers.add.desc.step1":
    "Enter the contact information and set a password for the manager. Once created you can set the number of accounts and archives that can be activated by the manager and assign the domains to be managed.",
  "managers.add.title.step1": "New manager",
  "managers.list.header.dsc":
    "Managers have access to the settings of the domains assigned to them and of the accounts present in them according to the limitations imposed by the administrator.",
  "managers.list.header.title": "Managers",
  "managers.settings.deliverySettings.assignResource.modalTitle": "Assign a resource to the manager",
  "migration.step.label1": "First migration round",
  "migration.step.label2": "Change MX records",
  "migration.step.label3": "Second migration round",
  "migration.step.text1": "Most of you messages will be migrate during this round.",
  "migration.step.text2":
    "When the first migration is completed you will receive an email and you will have to change the MX records. After change of records the messages start to arrive on our servers.",
  "migration.step.text3":
    "Your new messages are already arriving in our servers. In this round we will get the last ones remained on your old provider.",
  "migration.step.title": "Configure your migration",
  "migration.step.warning3": "Choose a time that  will allow you to change the MX records.",
  "migrationOptions.list.header.title": "Migration options",
  "migrations.add.desc":
    "Create the .CSV file with the necessary information and transfer the content of your email accounts from your old server / provider in a massive way.",
  "migrations.add.title": "New migration",
  "migrations.list.header.dsc":
    "Migrations allow you to transfer email messages from the old server / provider massively via IMAP through a .CSV file.",
  "migrations.list.header.title": "Migrations",
  "migrations.resources.details": "Details",
  "migrations.resources.header.title": "Migration",
  "migrations.resources.runDetailsCrashed": "An error occurred during the operation. Contact support.",
  "migrations.resources.runDetailsInterrupted": "The migration was interrupted with the following errors:",
  "migrations.resources.runDetailsSuccess": "The operation has been completed successfully",
  "modal.add.destination.title": "Add destination",
  "modal.cantDowngradeBasic.desc":
    "You need to resize the email accounts of 50GB of this plan because this option is not available on this plan",
  "modal.cantDowngradeBasic.title": "You can't downgrade to Basic plan",
  "modal.change.password.title": "Change password",
  "modal.change.passwordExpired.title": "Your password is expired, pick a new one now:",
  "modal.delete.archive.delegate.text":
    "You are deleting the delegate <code>{name}</code>.<br/><b>This operation cannot be reversed.</b>",
  "modal.delete.archive.delegate.title": "Delete delegate",
  "modal.delete.archive.domain.text":
    "You are deleting the domain archive <code>{domain}</code>.<br/>All archived messages will be deleted. <br/><b>This operation cannot be reversed.</b>",
  "modal.delete.archive.domain.title": "Delete domain archive",
  "modal.delete.archive.emailAccount.text":
    "You are deleting the account archive <code>{emailAccount}</code>.<br/>All archived messages will be deleted.<br/><b>This operation cannot be reversed.</b>",
  "modal.delete.archive.emailAccount.title": "Delete account archive",
  "modal.delete.customization.text":
    "You are deleting the theme for <code>{company}</code> company.<br/><b>This operation cannot be reversed.</b>",
  "modal.delete.customization.title": "Delete theme",
  "modal.delete.deliveryAccount.checkboxMsg":
    "Keep the account active until the end of the billing cycle and then delete automatically.",
  "modal.delete.deliveryAccount.text.free": "You are attempting to delete the account {accountData}.",
  "modal.delete.deliveryAccount.text.monthly":
    "You are attempting to delete the account {accountData}. Deleting the account will result in the loss of suppression list addresses associated with the account: if you haven't done so already, export the list before deleting the account.</br></br>The account has a subscription plan: you can choose to delete the account immediately or at the end of the billing cycle.",
  "modal.delete.deliveryAccount.text.prepaid":
    "You are attempting to delete the account {accountData}. Deleting the account will result in the loss of suppression list addresses associated with the account: if you haven't done so already, export the list before deleting the account.</br></br>The account has a remaining credit for messages to be sent. By deleting the account, the credit will be lost.",
  "modal.delete.deliveryAccount.title": "Delete the account",
  "modal.delete.deliveryAccount.warningMsg": "The process is not reversible",
  "modal.delete.deliveryDomain.text":
    "You are trying to delete the domain <code>{domainName}</code>. By deleting the domain, you will lose the ability to send via the SMTP protocol and the account-domain associations will be deleted.",
  "modal.delete.deliveryDomain.title": "Delete domain from Email Delivery",
  "modal.delete.emailAccount.text":
    "You are deleting the account <code>{emailAccount}</code>.<br/><b>This operation cannot be reversed.</b>",
  "modal.delete.emailAccount.title": "Delete email account",
  "modal.delete.import.text":
    "You are deleting the import <code>{importCode}</code>.<br/><b>This operation cannot be reversed.</b>",
  "modal.delete.import.title": "Delete import",
  "modal.delete.manager.text":
    "You are deleting the manger <code>{name}</code>.<br/><b>This operation cannot be reversed.</b>",
  "modal.delete.manager.title": "Delete manager",
  "modal.delete.migration.text":
    "You are deleting the migration <code>{migrationCode}</code>.<br/><b>This operation cannot be reversed.</b>",
  "modal.delete.migration.title": "Delete migration",
  "modal.delete.teamMember.text":
    "You are deleting the team member <code>{name}</code>.<br/><b>This operation cannot be reversed.</b>",
  "modal.delete.teamMember.title": "Delete team member",
  "modal.disable.archive.domain.text": "You are deactivating the domain archive <code>{domain}</code>.",
  "modal.disable.archive.domain.title": "Disable domain archive",
  "modal.disable.archive.emailAccount.text": "You are deactivating the account archive <code>{emailAccount}</code>.",
  "modal.disable.archive.emailAccount.title": "Disable account archive",
  "modal.disable.emailAccount.text":
    "You are disabling the account <code>{emailAccount}</code>.<br/>Messages will not be received and an automatic response will be sent.<br/>If the Email archive service is active on this box, the new messages that will be received will not be archived. You can still access the Archive and consult the old messages. <br/> We suggest to change the password of the email box if you want to block access to the related Archive.</b>",
  "modal.disable.emailAccount.title": "Disable email account",
  "modal.enable.emailAccount.text":
    "You are enabling the account <code>{emailAccount}</code>.<br/>The messages will be received again and the automatic reply will be disabled.<br/>If the Email Archive service is active, the new messages will start to be archived.",
  "modal.enable.emailAccount.title": "Enable email account",
  "modal.etlive.whereIsTitle": "Search Result",
  "modal.firstLogin.password.desc":
    "We have updated our panel, now you can access all your accounts with a single password.<br/>Set a new password for all accounts connected to the address <code>{emailAccount}</code>.",
  "modal.firstLogin.password.title": "Set new password",
  "modal.import.archive.text":
    "The import will go back to <code>{retentionAccount} {duration}</code>.<br/>Select the folders from which you want to import the messages and choose where to store their content. All messages in the selected folders will be split as you indicate and organized by year.<br/><br/><b>In:</b> stores the contents of the folders in receipts<br/><b>Out:</b> store the contents of folders in sent<br/><b>Ignore:</b> the contents of the folder are not stored",
  "modal.import.archive.title": "Import messages into archive",
  "modal.import.started.archive.text":
    "All messages in your mailbox will be imported and divided by year, ordering sent and received, as you chose.",
  "modal.import.started.archive.title": "Import messages started",
  "modal.log.migration.detail.title": "Migration details",
  "modal.log.migration.title": "Migration log",
  "modal.manager.delivery.confirm.body":
    "Are you sure you want to remove the management of <b>{resource}</b> from the manager?",
  "modal.manager.delivery.confirm.title": "Remove resource from the manager",
  "modal.mx.customer.desc": "Can be left empty if the custom MX are not associated with any customer",
  "modal.noAction.title": "Action not allow",
  "modal.otp.access.desc":
    "Enter the temporary password generated with the Google Authenticator® application to access the control panel.",
  "modal.otp.access.title": "One Time Password",
  "modal.otp.app.desc":
    "To activate and start using OTP authentication, download and install the application on your mobile device:",
  "modal.otp.app.title": "OTP authentication",
  "modal.otp.disable.desc":
    "Enter the temporary password generated with the Google Authenticator® application to disable OTP authentication. <br/> You can reactivate the OTP authentication by accessing your account settings.",
  "modal.otp.disable.title": "Disable OTP for this account",
  "modal.otp.enable.desc":
    "Scan the QRCode with the Google Authenticator® application or enter the code manually and use the temporary password generated to activate OTP authentication.",
  "modal.otp.enable.title": "Enable OTP for this account",
  "modal.paidOption.desc": "You selected a paid option, on saving settings it will be added to the next invoice.",
  "modal.paidOption.title": "Paid option",
  "modal.planDowngradeBasic.desc":
    "By downgrading to the Basic plan <b>you will lose</b> for all domain email accounts: <br /><ul><li class='ml-5'>• Email accounts up to 50 GB</li><li class='ml-5'>• Shared calendar and address book (including all data)</li><li class='ml-5'>• Centralized signature management</li><li class='ml-5'>• Increased security options</li><li class='ml-5'>• Custom logo for the domain</li><li class='ml-5'>• Antimalware Premium</li></ul> <br />Are you sure you want to proceed?",
  "modal.planDowngradeBasic.title": "Downgrade your plan to Basic",
  "modal.planDowngradeProfessional.desc":
    "By downgrading to the Professional plan <b>you will lose</b> for all domain email accounts: <br /><ul><li class='ml-5'>• Email accounts up to 100 GB</li><li class='ml-5'>• Microsoft® Exchange ActiveSync</li><li class='ml-5'>• Some security options</li></ul> <br />Are you sure you want to proceed?",
  "modal.planDowngradeProfessional.title": "Downgrade your plan to Professional",
  "modal.planUpgradeEnterprise.desc":
    "By upgrading to the Enterprise plan you will have available for all domain email accounts: <br /><ul><li class='ml-5'>• All the features of the Professional</li><li class='ml-5'>• Email accounts up to 100 GB</li><li class='ml-5'>• Microsoft® Exchange ActiveSync</li><li class='ml-5'>• Additional security options</li></ul>  <br /> Do you want to proceed?",
  "modal.planUpgradeEnterprise.title": "Plan Upgrade to Enterprise",
  "modal.planUpgradeProfessional.desc":
    "By upgrading to the Professional plan you will have available for all domain email accounts: <br /><ul><li class='ml-5'>• Email accounts up to 50 GB</li><li class='ml-5'>• Shared calendar and address book</li><li class='ml-5'>• Centralized signature management</li><li class='ml-5'>• Increased security options</li><li class='ml-5'>• Custom logo for the domain</li><li class='ml-5'>• Antimalware Premium</li></ul> <br /> Do you want to upgrade?",
  "modal.planUpgradeProfessional.title": "Plan Upgrade to Professional",
  "modal.recoveryPassword.desc":
    "To recover your password and access the control panel, enter your email address for recovery and follow the instructions we will send you.",
  "modal.recoveryPassword.disabled": "Recovery password is <b>disabled</b> for this account",
  "modal.recoveryPassword.title": "Password recovery",
  "modal.reseller.desc":
    "Reseller is who buy the services of Qboxmail primarily to resell them to third parties, he must be in possession of VAT and can only place orders with monthly invoicing.<br/><b>The reseller qualification is subject to approval.</b>",
  "modal.reseller.title": "Reseller",
  "modal.resellerOrCompany.company.desc":
    "Choose this option if you will use the Qboxmail service to <b>manage your company's mailboxes.</b>",
  "modal.resellerOrCompany.company.input.label": "I'm a company",
  "modal.resellerOrCompany.company.title": "For companies",
  "modal.resellerOrCompany.desc":
    "Are you a reseller or a company?<br/>We will optimise your Control Panel experience according to your choice.",
  "modal.resellerOrCompany.reseller.desc":
    "Choose this option if you will use the Qboxmail service to <b>manage your customers' mailboxes.</b>",
  "modal.resellerOrCompany.reseller.input.label": "I'm a reseller",
  "modal.resellerOrCompany.reseller.title": "For resellers",
  "modal.resellerOrCompany.submitButton": "Confirm",
  "modal.resellerOrCompany.title": "Welcome! Optimise your Control Panel",
  "modal.reset.password.title": "Reset password",
  "modal.restore.deliveryAccount.text.free": "If you restore the service, the user's subscription will resume.",
  "modal.restore.deliveryAccount.title": "Restore user service",
  "modal.settingsWebmail.signature.applyTo.desc.1": "All domain email accounts already have a signature set up.",
  "modal.settingsWebmail.signature.applyTo.desc.2":
    "The signature template will be set for all email accounts, listed below, that do not yet have a signature set up:",
  "modal.settingsWebmail.signature.applyTo.title": "Apply signature to accounts",
  "modal.settingsWebmail.signature.applyToAll.desc":
    "The signature template will be applied to all domain email accounts.<br/>Any existing signatures will be override.<br/><b>The operation is not reversible.</b>",
  "modal.settingsWebmail.signature.applyToAll.title": "Apply signature to all",
  "modal.settingsWebmail.signature.missingField.desc.1": "Some domain email accounts don't have the field",
  "modal.settingsWebmail.signature.missingField.desc.2":
    "Using this tag, the corresponding field will be blank for these accounts.",
  "modal.settingsWebmail.signature.missingField.title": "Email accounts without field",
  "modal.trial.days.left": "Days left",
  "modal.trial.desc":
    "At the end of the trial period the account will be disabled. Don't wait until the last moment!<br/><b>Buy now and unlock advanced features.</b>",
  "modal.trial.desc.endTrial":
    "Your account has been disabled.<br/><b>Buy to enable the account and unlock advanced features.</b>",
  "modal.trial.title": "Trial period",
  "modal.ugradeRequired.plan.title": "Plan upgrade required",
  "modal.ugradeRequired.quota.desc":
    "To increase the size of one or more email accounts, you need to upgrade your domain plan. Activate the <b>Professional plan to have up to 50 GB</b> of space for your accounts or the <b>Enterprise plan for 100 GB accounts</b>.<br/><br/>To upgrade domain plan go to <code>Domain settings > General > Plan management</code> and select the plan that corresponds to your needs.",
  "modal.withArchive.domain":
    "This domain has archive active, so it cannot be deleted. Delete the archive first to delete the domain.",
  "modal.withArchive.emailAccount":
    "This email account has archive active, so it cannot be deleted. Delete the archive first to delete the domain.",
  "mtm.cardDayLabel": "Day to restore:",
  "mtm.cardHeader": "Restore requested on {date}",
  "mtm.cardMailLabel": "Email account:",
  "mtm.completed": "Restore completed successfully",
  "mtm.denied": "Request denied",
  "mtm.errored": "Error during restore. Contact support",
  "mtm.expired": "Backup expired",
  "mtm.expiresAtLabel": "Backup available until",
  "mtm.noRequests": "No pending requests",
  "mtm.pendingRequests": "You have pending backup restore requests",
  "mtm.running": "Restore in progress",
  "mtm.sectionDesc": "Manage your users' Mail Time Machine backup restore requests",
  "mtm.sectionTitle": "Backup restore requests",
  "mxrecords.list.desc": "Manage custom MX for private labels",
  "mxrecords.list.title": "Custom MX",
  "navbar.appSwitch.mailboxes": "Email Hosting",
  "navbar.trial.end.warningMsg": "Your trial has expired",
  "navbar.trial.waitPay": "You have an order pending payment",
  "navbar.trial.warningMsg": "Your trial will end in {daysLeft} p{day/days}",
  "order.add.congratulation.desc":
    "Soon you will receive an email, at <code>{email}</code>, with a summary of your order and payment instructions.",
  "order.add.congratulation.orderNumber": "The number of your order is <code>{code}</code>",
  "order.add.congratulation.subtitle": "Once payment is received, the service will be activated within a few hours.",
  "order.add.congratulation.title": "Thank you for ordering Qboxmail services",
  "order.add.desc.step1":
    "Select the country where your company is located or, if you are a private user, the country where you reside.",
  "order.add.desc.step2":
    "Indicate if you intend to use the service only for you, or for your company, or if you intend to buy it to resell it to a third party.",
  "order.add.desc.step3":
    "To proceed with the order we need your data or the company to which the service will be headed.",
  "order.add.desc.step4": "Choose the billing type and payment method that best suits your needs.",
  "order.add.desc.step5.annual":
    "Select all the emil domains and accounts you need, choosing the plan that best suits your needs. Once the order is completed, you will be able to activate domains and email accounts that you have freely chosen.",
  "order.add.desc.step5.monthly":
    "These are your domains and email accounts currently active. Once the order is completed the limits from your user will be removed and you will be able to activate new domains and email accounts.",
  "order.add.desc.step7": "Payment instructions will be sent to <code>{emailAddress}</code>.",
  "order.add.title.step1": "Geographic area",
  "order.add.title.step2": "User type",
  "order.add.title.step3": "Contact information",
  "order.add.title.step4": "Billing and payment methods",
  "order.add.title.step5": "Domains and email accounts",
  "order.add.title.step6": "Order summary",
  "order.counter.addAccounts": "Insert the number of email accounts you want to add to your domain.",
  "order.counter.archive": "Archives Emails Options",
  "order.counter.emailAccount.100GB": "Email accounts 100GB",
  "order.counter.emailAccount.50GB": "Email accounts 50GB",
  "order.counter.emailAccout.25GB": "Email accounts 25GB",
  "order.counter.emailAccout.8GB": "Email accounts 8GB",
  "order.counter.paidOptions": "Insert the number of additional options you want to activate on your email accounts.",
  "order.counter.price.annual": "year",
  "order.counter.price.monthly": "month",
  "order.fee.invoiceCalc.monthly":
    "The amount indicated refers to the entire month. The exact amount will be calculated based on the date of the order completion.",
  "order.fee.priceVat": "All prices are <b>VAT excluded</b>.",
  "order.label.first.bill.annual": "Annual fee",
  "order.label.first.bill.annualTotal": "Total Annual fee",
  "order.label.first.bill.monthly": "Monthly price",
  "orders.list.card.field.date": "Order created",
  "orders.list.card.field.dateEdit": "Edit order",
  "orders.list.card.field.dateExpire": "Expiration",
  "orders.list.card.field.em25gb": "Email account 25 GB",
  "orders.list.card.field.em8gb": "Email account 8 GB",
  "orders.list.card.field.emArchive": "Email archives",
  "orders.list.card.field.plan": "Plan",
  "orders.list.card.field.total": "Total price",
  "orders.list.card.field.waitingPayment": "Waiting for payment",
  "orders.list.header.dsc": " ",
  "orders.list.header.newDomain": "Order domain",
  "orders.list.header.title": "Orders",
  "orders.new.alert.noDomainsWithNoEmails": "It is not possible to order a domain without email accounts",
  "orders.new.alert.noEmptyOrder": "It is not possible to complete an order without at least 1 email account",
  "orders.new.alert.noIncompleteDomains": "Complete the information for all domains",
  "orders.new.recap.addedForMinimum": "Email accounts added to reach minimum order",
  "orders.new.recap.price": "price € {price}",
  "orders.new.recap.resellerWarn":
    "If you are a reseller, you can request the reseller discount starting from the second month of billing on the prices page of the Panel.",
  "orders.show.calc.action.question": "What kind of upgrade do you want to do on the domain?",
  "orders.show.calc.whmcs.total": "Calc price",
  "orders.show.step1.desc":
    "Upgrade your domain by changing the current plan assigned to it or the number of email accounts that can be activated.",
  "orders.show.step1.desc.emails":
    "Add new email accounts or increase the number of additional options you can activate for your domain accounts",
  "orders.show.step1.desc.plan": "Upgrade your domain plan and access advanced features.",
  "orders.show.step1.title": "Domain upgrade",
  "orders.show.step1.title.emails": "Add email accounts",
  "orders.show.step1.title.plan": "Plan upgrade",
  "ownershipCheck.dns.instruction.part1":
    "To verify the ownership you need to create the record type A below in the configuration of the DNS of the domain:",
  "ownershipCheck.dns.instruction.part2":
    "Once you have created the record, click on <code>Verify DNS</code> to enable the domain. It could take up to 24 hours until the new configuration will work.<br/>Last check:",
  "ownershipCheck.email.instruction.part1":
    "Verify domain ownership by code. Choose an address, among those listed, in which to receive the verification code.",
  "ownershipCheck.email.instruction.part2":
    "We have sent an email to <code>{emailAddress}</code>.<br/>Use the verification code that you find in the message to complete the operation.",
  "ownershipCheck.html.instruction.part1":
    "Verify the ownership of the domain through files, generated by our systems, to be added to the site root.",
  "ownershipCheck.html.instruction.step1.title": "1. Download verify file",
  "ownershipCheck.html.instruction.step2.desc1":
    "Upload the file to the root of the site associated with the domain, without changing its name or content, making sure that the file is visible to the url:",
  "ownershipCheck.html.instruction.step2.desc2":
    "If following this link you get an error or a 404 page it means that the file is not uploaded correctly",
  "ownershipCheck.html.instruction.step2.title": "2. Upload the file to the site root",
  "ownershipCheck.html.instruction.step3.desc1":
    "If the file is correctly positioned, complete the procedure by clicking on <code>Verify</code>",
  "ownershipcheck.title": "Ownership check",
  "plan.basic.desc": "For professionals or companies that want a convenient and quality service.",
  "plan.basic.fullName": "Piano Basic",
  "plan.basic.name": "Basic",
  "plan.enterprise.desc":
    "For organizations that require advanced communication tools for their employees and high security in the use of services.",
  "plan.enterprise.fullName": "Piano Enterprise",
  "plan.enterprise.name": "Enterprise",
  "plan.professional.bestLabel": "Most popular",
  "plan.professional.desc":
    "For companies that need to coordinate and communicate with all their employees in a simple and intuitive way.",
  "plan.professional.fullName": "Professional",
  "plan.professional.name": "Professional",
  "postmasters.list.header.dsc":
    "Postmasters are email accounts responsible for managing your domain and are automatically created when a new domain is activated.",
  "postmasters.list.header.title": "Postmasters",
  "prices.additionalServices.title": "Additional Services",
  "prices.annualTier.tableTitle": "Prices for annual subscriptions",
  "prices.archive.annual.label": "Archive for annual subscription",
  "prices.archive.desc":
    "Cloud storage, search and export of all received and sent messages, storing them for up to 10 years. Activate it in the <Link to='/archive'>Archive</Link> section of the Panel. <b>Prices are per Archive activated on a single mailbox.</b>",
  "prices.archive.label": "Archive",
  "prices.archive.monthly.label": "Archive for monthly subscription",
  "prices.archive.title": "Security email archive",
  "prices.backup.label": "Restore",
  "prices.backup.title": "Backup restore",
  "prices.contactUs": "Contact us",
  "prices.ctaNotReady":
    "You are in the appropriate discount bracket based on the number of email accounts. When you will pass the limit for this plan you can request to join the next discount tier.",
  "prices.custom.sectionSubtitle": "Below are the details of the prices per mailbox according to the plan applied.",
  "prices.custom.sectionTitle": "Plan prices",
  "prices.custom.tier.disclaimer": "Prices are per single mailbox.",
  "prices.customQuotaContactUs":
    "You have reached 200 email accounts, contact us to discuss a customised discount plan.",
  "prices.customTierMsg":
    "You have <b>{count}</b> billable email accounts.Below you can find the pricing breakdown of your discounted plan for our Resellers.",
  "prices.dailyMessages.annuallyPrices": "Prices for annual subscriptions",
  "prices.dailyMessages.desc":
    "For each e-mail account, it is possible to set the limit of messages that can be sent every 24 hours. Cuts of 250, 1,000, 2,000 and 5,000 messages are available.",
  "prices.dailyMessages.monthlyPrices": "Prices for monthly subscriptions",
  "prices.dailyMessages.title": "Daily sending limits",
  "prices.disclaimer":
    "The prices are for each email account, excluding VAT. Discounts are bounded to Qboxmail's terms and conditions.",
  "prices.disclaimerAnnual": "The prices are for each email account, excluding VAT.",
  "prices.enduser.additionalServices.desc":
    "You can take advantage of other services in association with your mailbox.",
  "prices.enduser.annualTier.disclaimer": "Prices are per single mailbox excluding VAT.",
  "prices.enduser.monthlyTier.disclaimer":
    "Prices are per single mailbox, excluding VAT.<br/>The minimum billable in this type of subscription is 5 mailboxes.",
  "prices.enduser.sectionSubtitle":
    "The price of individual mailboxes is indicated according to size, plan and subscription type.",
  "prices.howMany": "You have <b>{count} billable email accounts </b>.",
  "prices.howManyAnnual":
    "You have <b>{count}</b> billable email accounts. <br/>Check the number of email accounts in the orders section. <br/>If you want to buy more email accounts open a ticket to our support system.",
  "prices.howManyLessThan5": "You have <b>{count} billable email accounts </b>. This tier's minimum number is 5.",
  "prices.howManyNotReseller": "You have <b>{count} billable email accounts </b>. This tier's minimum number is {min}.",
  "prices.howManySubtitle": "Create new email accounts to unlock the next discount tier",
  "prices.howManySubtitleLastTier": "Create new email accounts to access to dedicated discounts",
  "prices.is_rn":
    "WARNING, your current discounted price is based on an old pricing policy. Today this price does not allow us to sustain the effort of keeping the service running. In the future an appropriate discount tier based on the email accounts volume will be applied",
  "prices.is_rold":
    "WARNING, your current discounted price is based on an old pricing policy. Today this price does not allow us to sustain the effort of keeping the service running. In the future an appropriate discount tier based on the email accounts volume will be applied.",
  "prices.lessThan10": "Once you have more than 10 email accounts you can request access to our resellers' discounts.",
  "prices.lower_than_min":
    "WARNING, the number of billable email accounts is less than the lower limit of this discount tier. If you don't activate new email accounts the next month the rate of the appropriate discount tier will be applied.",
  "prices.missing": "{missing} email accounts to next discount",
  "prices.monthlyTier.tableTitle": "Prices for monthly subscriptions",
  "prices.navbarTooltipDesc": "Show your plan",
  "prices.navbarTooltipTitle": "Pricing",
  "prices.ongoingUpgrade": "We received your request to join the next discount tier. We will contact you soon",
  "prices.paid.backup.desc":
    "Restoring an email account backup to one of the 15 days prior to today's date. To request it, just connect to your account's Mail Time Machine. Prices are intended for a single restoration upon request.",
  "prices.paid.enduser.archive.desc":
    "Cloud storage, search and export of all received and sent messages, storing them for up to 10 years. Activate it in the <Link to='/archive'>Archive</Link> section of the Panel. <b>Prices are per Archive activated on a single mailbox.</b>",
  "prices.privateLabel.desc":
    "The Private Label allows you to customize the access parameters to the POP, IMAP, SMTP, DAV, Webmail, Control Panel, Mail Time Machine and Archive services with your own domain, so that the SSL certificate is valid. Customization also includes MX and SPF records.",
  "prices.privateLabel.label": "Private Label",
  "prices.privateLabel.title": "Private Label customisation",
  "prices.promoMsg":
    "You are in this discounted tier because of a tailored offer. The terms of the offer have been agreed with you in advance.",
  "prices.request": "Send request",
  "prices.requested": "Requested",
  "prices.reseller.additionalServices.desc":
    "Additional services allow you to customise and increase the value of your email service offer.",
  "prices.reseller.sectionSubtitle":
    "Depending on the number of active and billed mailboxes, there are dedicated discount bands. Prices refer to the cost of a single mailbox.",
  "prices.reseller.tier.disclaimer": "Prices are per single mailbox excluding VAT.",
  "prices.sectionSubtitleAnnual":
    "On this page you can find your price range with the breakdown for each email account based on the size and plan.",
  "prices.sectionTitle": "Email accounts pricing",
  "prices.servicesAccess.info": "Access your customer area to view your active services and invoices.",
  "prices.tableLabel.mailboxes": "mailboxes",
  "prices.tierMinMsg": "Minumum billable email accounts for this plan: {min}",
  "prices.trial.backup.desc":
    "Restoring all messages from an email account to one of the 15 days prior to today's date. To request it, just connect to your account's Mail Time Machine.",
  "prices.trial.reseller.archive.desc":
    "Cloud storage, search and export of all received and sent messages, storing them for up to 10 years. Activate it in the <Link to='/archive'>Archive</Link> section of the Panel.",
  "prices.trial.reseller.tierInfo":
    "Fill in the form to download the <b>Reseller Program</b> and discover the prices and discount ranges reserved for resellers.",
  "prices.upgrade": "You have reached the number of email accounts needed to request access to our next discount tier.",
  "prices.upgradeNotStandard": "You have reached 200 email accounts, contact us to discuss your discount plan.",
  "prices.webLabel.desc":
    "The Web Label allows you to customize the access URLs to services with SSL certificate. You can use a domain of your choice, for example the name of your company or that of your customers. You can choose to customize the following modules:<br/><span class='ml-5'>• 1st module: Webmail</span><br/><span class='ml-5'>• Other modules : Control Panel, Mail Time Machine, Archive.</span>",
  "prices.webLabel.firstModule": "1st module",
  "prices.webLabel.secondModule": "From the 2nd module",
  "prices.webLabel.title": "Web Label Customisation",
  "prices.webLabelModule": "module",
  "qbmove.error.auth_failed": "User <b>{user}</b> authentication with server <b>{host}</b> failed",
  "qbmove.error.connection_failed": "Connection for user {user} to {host} failed",
  "qbmove.error.folder_create_failed": "Unable to create the folder {folder}",
  "qbmove.error.folder_select_failed": "Unable to select the folder {folder}",
  "qbmove.error.imapsync_not_installed": "Imapsync not installed",
  "qbmove.error.max_size_exceeded":
    "The message with UID {uid} in the folder {folder} exceeds the maximum allowed size",
  "qbmove.error.message_fetch_failed": "Unable to fetch the message with UID {uid} in the folder {folder}",
  "qbmove.error.overquota": "The destination mailbox has run out of available space",
  "qbmove.error.quota_exceeded": "Unable to migrate the message with UID {uid} in the folder {folder}: quota exhausted",
  "qbmove.error.ssh_connect_denied": "SSH connection failed",
  "qbmove.error.temporary_unavailable": "Connection for user {user} to {host} temporarily unavailable",
  "qbmove.error.unhandled_error": "Unknown error, contact support for more information",
  "qbmove.file_errors": "Invalid file",
  "qbmove.first_execution": "First execution",
  "qbmove.second_execution": "Second execution",
  "qbmove.status.completed": "Completed",
  "qbmove.status.failed": "Failed",
  "qbmove.status.running": "Running: {percentage}%",
  "qbmove.status.runningTest": "Running test",
  "qbmove.status.soon": "Soon",
  "qbmove.test_run": "Test authentication",
  "radiobtn.desc.customer.company": "Freelancer or company with VAT number.",
  "radiobtn.desc.customer.private": "User with Fiscal Code, but not VAT number.",
  "radiobtn.desc.customer.reseller":
    "Freelancer or company, with VAT Number or other Company Registration Number, who buys the service to resell it to third parties.",
  "radiobtn.desc.payment.bankTransfer":
    "By choosing this payment method, your domains will be available after we receive the amount credited. In the summary email you will find instructions for making the payment.",
  "radiobtn.desc.payment.creditCard":
    "Automate the payment of invoices via your credit/debit card. All major circuits are accepted, e.g. Visa, Mastercard, American Express. The charge will be made on the due date of the invoice.",
  "radiobtn.desc.payment.paypal":
    "Make the payment using your PayPal account. You will have to pay the invoices manually by following the instructions in the proforma by the due date.",
  "radiobtn.desc.payment.paypal.auto":
    "Automate the payment of invoices via your PayPal account. The charge will be made on the due date of the invoice.",
  "radiobtn.label.accept": "Agree",
  "radiobtn.label.customer.company": "Company",
  "radiobtn.label.customer.private": "Private [only for residents in Italy]",
  "radiobtn.label.customer.reseller": "Reseller",
  "radiobtn.label.noAccept": "Disagree",
  "radiobtn.label.payment.bankTransfer": "Bank transfer",
  "radiobtn.label.payment.lcwsoftpaypalbillingagreements": "PayPal with automatic debit",
  "radiobtn.label.payment.paypal": "PayPal with manual debit",
  "radiobtn.label.payment.stripe": "Card with automatic debit",
  "report.desc.archive": "All the email archives active in this moment in your account.",
  "report.desc.domain": "All the domains active in this moment in your account.",
  "report.desc.domain.alias": "All the alias domains active in this moment in your account.",
  "report.desc.domain.limits":
    "All the domains (with the details about their limits) active in this moment in your account.",
  "report.desc.emailAccount": "All the email accounts active in this moment in your account.",
  "report.desc.emailAccount.alias": "All the alias emails active in this moment in your account.",
  "report.list.header.dsc":
    "Let you download a detailed report, in CSV format.<br/>You can open it with Excel and filter it as you prefer.",
  "report.list.header.title": "Report",
  "report.title.archive": "Archives Report",
  "report.title.domain": "Domains Report",
  "report.title.domain.alias": "Alias Domains Report",
  "report.title.domain.limits": "Domains Limits Report",
  "report.title.emailAccount": "Email Accounts Report",
  "report.title.emailAccount.alias": "Alias Email Report",
  "reset.password.desc":
    "Choose the password to access your Control panel.<br/>We recommend to use a secure password of at least 8 alphanumeric characters.",
  "reset.password.title": "Set password",
  "section.view.account.email": "Email account",
  "section.view.account.email.settings": "Email account settings",
  "section.view.admin": "Admin",
  "section.view.alias.email": "Email alias",
  "section.view.archive.account.email": "Archive email account",
  "section.view.archive.domain": "Archive domain",
  "section.view.customer": "Customer",
  "section.view.delegate": "Delegate",
  "section.view.domain": "Domain",
  "section.view.domain.settings": "Domain settings",
  "section.view.import.resources": "Import resources",
  "section.view.manager": "Manager",
  "section.view.migration.resources": "Migration resources",
  "section.view.postmaster.settings": "Postmaster settings",
  "section.view.teamMember": "Team member",
  "section.view.user.settings": "User settings",
  "select.status.accept": "Accepted",
  "select.status.accepted": "Accepted",
  "select.status.account": "Account",
  "select.status.all": "All",
  "select.status.authfailed": "Errors",
  "select.status.blocked": "Blocked",
  "select.status.completed": "Completed",
  "select.status.completed_with_errors": "Completed with errors",
  "select.status.crashed": "Crashed",
  "select.status.delivery.domainsAggregation": "Aggregate by domain",
  "select.status.delivery.singleDomain": "Single domain",
  "select.status.disabled": "Disabled",
  "select.status.enabled": "Enabled",
  "select.status.error": "Errors",
  "select.status.expired": "Expired",
  "select.status.failed": "Failed",
  "select.status.failure": "Errors",
  "select.status.free": "Free",
  "select.status.invalid": "Not valid",
  "select.status.login-error": "Errors",
  "select.status.migrating": "In progress",
  "select.status.migrationResources.all": "All",
  "select.status.migrationResources.failed": "Failed",
  "select.status.migrationResources.running": "Running",
  "select.status.migrationResources.success": "Completed",
  "select.status.ownership_check": "Waiting",
  "select.status.paid": "Paid",
  "select.status.qbmove.all": "All",
  "select.status.qbmove.crashed": "Crashed",
  "select.status.qbmove.error": "Errors",
  "select.status.qbmove.running": "Running",
  "select.status.qbmove.scheduled": "Scheduled",
  "select.status.qbmove.success": "Completed",
  "select.status.qbmove.types.all": "All types",
  "select.status.qbmove.types.migration": "Migrations",
  "select.status.qbmove.types.vault_import": "Vault Import",
  "select.status.reject": "Rejected",
  "select.status.rejected": "Rejected",
  "select.status.running": "Running",
  "select.status.scheduled": "Scheduled",
  "select.status.spam-mark": "Marked spam",
  "select.status.success": "Accesses",
  "select.status.suppressionList.all": "All",
  "select.status.suppressionList.disabled": "Delivery enabled",
  "select.status.suppressionList.enabled": "Delivery blocked",
  "select.status.trial": "Trial",
  "select.status.unhealthy": "Update MX Records",
  "select.status.updating": "Updating",
  "select.status.valid": "Valid",
  "select.status.validating": "Validating",
  "select.status.waiting": "Waiting",
  "select.status.with errors": "Errors",
  "select.value.accesses": "Access info",
  "select.value.aliasDomains": "Domains alias",
  "select.value.aliasEmails": "Emails alias",
  "select.value.all": "All",
  "select.value.allAccounts": "All accounts",
  "select.value.annually": "Annual",
  "select.value.crashed": "Crashed",
  "select.value.de": "German",
  "select.value.domains": "Domains",
  "select.value.dutch": "Dutch (Applied only on webmail, panel will remain in english)",
  "select.value.emailAccounts": "Email accounts",
  "select.value.english": "English",
  "select.value.error": "Errors",
  "select.value.es": "Spanish",
  "select.value.fr": "French",
  "select.value.gr": "Greek",
  "select.value.hour": "hour",
  "select.value.hours": "hours",
  "select.value.imap": "IMAP",
  "select.value.italian": "Italian",
  "select.value.mail.in": "Mail received",
  "select.value.mail.out": "Mail sent",
  "select.value.monthly": "Monthly",
  "select.value.never": "Never",
  "select.value.nl": "Dutch",
  "select.value.pop": "POP",
  "select.value.pt": "Portoguese",
  "select.value.scheduled": "Scheduled",
  "select.value.spanish": "Spanish",
  "select.value.sv": "Sweden",
  "select.value.webmail": "Webmail",
  "selectionCard.accounts": "Account",
  "selectionCard.domainsRanking": "Domains Ranking",
  "selectionCard.domainsRanking.short": "Dom. Ranking",
  "selectionCard.singleDomain": "Single Domain",
  "selectionCard.singleDomain.short": "Domain",
  sendMessages: "messages",
  "settings.alert.dkim.disableFailed": "Disabling DKIM failed",
  "settings.alert.dkim.resetFailed": "Reset DKIM failed",
  "settings.alert.dkim.verifyFailed": "DKIM DNS verification failed. Check DNS are configured correctly",
  "settings.domain.title": "Domain settings",
  "settings.msg.dkim.activating": "Activating DKIM signature",
  "settings.msg.dkim.disabling": "Disabling DKIM signature",
  "settings.section.postmaster.desc":
    "The postmaster is an email account as the others, but when login in this panel it can manage the resources of its domain.",
  "settings.section.postmaster.title": "Postmaster",
  "settings.sections.account.limits.desc.customer":
    "Set the number of domains, accounts and archives that can be activated by the customer.",
  "settings.sections.account.limits.desc.emailAccount": "Set the size of the email account.",
  "settings.sections.account.limits.title": "Account limits",
  "settings.sections.accounts.desc": "Set accounts management permissions for the team member.",
  "settings.sections.accounts.title": "Accounts management",
  "settings.sections.accountsLimits.title": "Accounts limits",
  "settings.sections.alias.title": "Alias",
  "settings.sections.analysis.desc": "Set access to analysis tools for the team member.",
  "settings.sections.analysis.title": "Analysis tools",
  "settings.sections.antimalwarePremium.desc":
    "Enable an additional layer of protection to protect the domain's mailboxes.",
  "settings.sections.antimalwarePremium.title": "Antimalware Premium",
  "settings.sections.antispam.desc": "Antispam level description",
  "settings.sections.antispam.desc.domain":
    "Set the sensitivity level of the antispam filter for domain accounts. We recommend that you keep the default.",
  "settings.sections.antispam.title": "Antispam level",
  "settings.sections.api.desc.customer": "Allow customer to access to panel via API.",
  "settings.sections.api.desc.domain": "Allow access to domain accounts via API.",
  "settings.sections.api.desc.emailAccount": "Allow access to email account via API.",
  "settings.sections.api.desc.panel": "Allow access to the panel via API.",
  "settings.sections.api.desc.teamMember": "Allow access to the team member via API.",
  "settings.sections.api.title": "API access",
  "settings.sections.archive.desc": "Set the archive management permissions for the team member.",
  "settings.sections.archive.import.desc":
    "Import process allows you to automatically store all your mailbox messages, dividing them between received and sent and organizing them by year.",
  "settings.sections.archive.import.title": "Import",
  "settings.sections.archive.info.title": "Archive info",
  "settings.sections.archive.newAccounts.desc": "Set default storage settings for new domain accounts.",
  "settings.sections.archive.newAccounts.title": "New accounts",
  "settings.sections.archive.retention.desc": "Choose the default retention period for domain account messages.",
  "settings.sections.archive.retention.desc.emailAccount":
    "Choose the default retention period for the email account messages.",
  "settings.sections.archive.retention.title": "Retention",
  "settings.sections.archive.title": "Archive management",
  "settings.sections.autoresponder.desc":
    "Set an automatic reply message to be sent during the time period you have chosen.",
  "settings.sections.autoresponder.title": "Autoresponder",
  "settings.sections.canEditOutbound.desc": "Disable outbound limits settings for the customer",
  "settings.sections.canEditOutbound.title": "Outbound Limits",
  "settings.sections.catchAll.desc": "Set an email address to send messages to in case of non-existent recipient.",
  "settings.sections.catchAll.desc.customer": "Set the possibility to activate the Catch all for the customer.",
  "settings.sections.catchAll.title": "Catch all",
  "settings.sections.customerData.desc": "Enter the customer's contact information.",
  "settings.sections.customerData.title": "Customer info",
  "settings.sections.customerLimits.title": "Limits",
  "settings.sections.customerOrder.title": "Customer order",
  "settings.sections.customerType.desc": "Set the type and expiry date of the customer",
  "settings.sections.customerType.title": "Customer type",
  "settings.sections.delegate.info.title": "Delegate info",
  "settings.sections.delivery.desc": "Set access to the Email Delivery service",
  "settings.sections.delivery.title": "Email Delivery",
  "settings.sections.deliverySettings.assignAccounts.desc":
    "Manually assign specific Email Delivery service users and domains to the manager. After assignment, the manager will have full control over them through the management panel.",
  "settings.sections.deliverySettings.assignAccounts.title": "Assigned Accounts & Domains",
  "settings.sections.deliverySettings.newResourcesLimit.desc":
    "Define the maximum number of Delivery accounts and domains the manager can have assigned.",
  "settings.sections.deliverySettings.newResourcesLimit.title": "Email Delivery Accounts & Domains limits",
  "settings.sections.dkim.desc": "Set a custom DKIM signature for the domain-",
  "settings.sections.dkim.title": "Custom DKIM signature",
  "settings.sections.domain.limits.desc":
    "Set the number of accounts and archives that can be activated for the domain and the size of the accounts it contains.",
  "settings.sections.domain.limits.title": "Domain limits",
  "settings.sections.domains.desc": "Set domains management permissions for the team member.",
  "settings.sections.domains.maxAccountSize":
    "The effective cost is always calculated based on the closest default size (8GB, 25GB, 50GB) to the selected size",
  "settings.sections.domains.maxAccountsAvailable":
    "Set the number of accounts and archives that can be activated for the domain.",
  "settings.sections.domains.maxAccountsAvailable.title": "Accounts available",
  "settings.sections.domains.title": "Domains management",
  "settings.sections.emailAccout.availableSpace": "Available space",
  "settings.sections.emailAccout.desc": "Enter the email account contact information.",
  "settings.sections.emailAccout.title": "Account info",
  "settings.sections.emailNotifications.desc":
    "Set an email address to receive alert notifications about domains and accounts.",
  "settings.sections.emailNotifications.title": "Email notifications",
  "settings.sections.forwards.desc":
    "Enter one or more alternative addresses to send messages received from the email account.<br/><b>You can enter up to 20 addresses</b>.",
  "settings.sections.forwards.title": "Forwards",
  "settings.sections.general.title": "General settings",
  "settings.sections.ipEnabled.desc.domain":
    "Restrict access to domain accounts to only the IP addresses you consider safe.<br/><b>You can enter up to 5 IP addresses / classes to apply restrictions for POP, IMAP, SMTP, Webmail and API services.</b>",
  "settings.sections.ipEnabled.desc.emailAccount":
    "Restrict access to email account to only the IP addresses you consider safe.<br/><b>You can enter up to 5 IP addresses / classes to apply restrictions for POP, IMAP, SMTP, Webmail and API services.</b>",
  "settings.sections.ipEnabled.desc.panel":
    "Restrict access to the panel and API only to the IP addresses you feel safe.",
  "settings.sections.ipEnabled.title": "IP enabled",
  "settings.sections.languageTimeZone.desc.customer": "Set the panel language and time zone for the customer.",
  "settings.sections.languageTimeZone.desc.domain":
    "Set the default language and the time zone for the domain and for the accounts it contains.",
  "settings.sections.languageTimeZone.desc.emailAccount":
    "Set the default language and the time zone for the email account.",
  "settings.sections.languageTimeZone.desc.panel": "Set the panel language and the time zone.",
  "settings.sections.languageTimeZone.title": "Language and time zone",
  "settings.sections.limits.access.desc":
    "Set the domains and accounts that the delegate can view. <b>You can authorize the delegate to access multiple domains and accounts</b>.",
  "settings.sections.limits.access.title": "Content access",
  "settings.sections.limits.time.desc": "Set the access interval of the delegate to the archive.",
  "settings.sections.limits.time.title": "Time limits",
  "settings.sections.managerLimits.desc":
    "Set the number of accounts and archives that the manager can activate and assign him the domains to manage.",
  "settings.sections.managerLimits.title": "Manager limits",
  "settings.sections.other.title": "Other",
  "settings.sections.otp.desc.domain": "Set two-factor authentication (OTP) policies for domain email accounts.",
  "settings.sections.otp.desc.emailAccount": "Set two-factor authentication (OTP) policies for the email account.",
  "settings.sections.otp.desc.panel": "Set two-factor authentication (OTP) to safety access the panel.",
  "settings.sections.otp.title": "OTP authentication",
  "settings.sections.password.desc": "Change password to access the panel.",
  "settings.sections.password.desc.admin": "Change admin password to access the panel.",
  "settings.sections.password.desc.customer": "Change customer password to access the panel.",
  "settings.sections.password.desc.delegate": "Change delegate password to access the archive.",
  "settings.sections.password.desc.domain": "Set password management policies for domain accounts.",
  "settings.sections.password.desc.emailAccount":
    "Change the password and set password management policies for the email account.",
  "settings.sections.password.desc.manager": "Change manager password to access the panel",
  "settings.sections.password.desc.panel": "Change your account password to access the panel",
  "settings.sections.password.desc.teamMember": "Change team member password to access the panel",
  "settings.sections.password.title": "Password",
  "settings.sections.passwordExpiration.desc": "Set password expiration policies for all domain account.",
  "settings.sections.passwordExpiration.emailDesc": "Set email account password expiration policies.",
  "settings.sections.passwordExpiration.title": "Password Expiration",
  "settings.sections.planManagement.desc":
    "Set a domain plan. The change of plan involves a change in the cost and available features.",
  "settings.sections.planManagement.title": "Plan management",
  "settings.sections.registry.desc.domain": "Enter the default contact information used for new email accounts.",
  "settings.sections.registry.title.domain": "Domain registry",
  "settings.sections.registryCompany.title": "Company information",
  "settings.sections.sentLimits.desc.domain":
    "Set the default daily message sending limit for the domain's email accounts.",
  "settings.sections.sentLimits.desc.emailAccount": "Set the daily message sending limit for the email account.",
  "settings.sections.sentLimits.title": "Daily sending limit",
  "settings.sections.services.desc": "Services description",
  "settings.sections.services.desc.domain":
    "Set the services available for domain accounts. <b>The services vary according to the plan selected for the domain</b>.",
  "settings.sections.services.desc.emailAccount":
    "Set the services available for the email account. <b>The services vary based on the plan and the domain settings</b>.",
  "settings.sections.services.title": "Services",
  "settings.sections.settingsWebmail.desc":
    "New email accounts of this domain will be create with these settings if not explicitly defined",
  "settings.sections.settingsWebmail.email.desc":
    "Webmail localization settings. These can help you configure the localization settings of the webmail. The user can update these values directly from the webmail",
  "settings.sections.settingsWebmail.email.title": "Localization",
  "settings.sections.settingsWebmail.signature.desc":
    "Centrally manage email signatures sent by all domain users. Enter a template for your signature and choose which users to apply it to.",
  "settings.sections.settingsWebmail.signature.field-c": "Country",
  "settings.sections.settingsWebmail.signature.field-c_uid": "Email address",
  "settings.sections.settingsWebmail.signature.field-facsimiletelephonenumber": "Fax",
  "settings.sections.settingsWebmail.signature.field-givenname": "Firstname",
  "settings.sections.settingsWebmail.signature.field-l": "City",
  "settings.sections.settingsWebmail.signature.field-mobile": "Mobile phone",
  "settings.sections.settingsWebmail.signature.field-mozillasecondmail": "Secondary Email",
  "settings.sections.settingsWebmail.signature.field-o": "Company",
  "settings.sections.settingsWebmail.signature.field-ou": "Organizational Unit",
  "settings.sections.settingsWebmail.signature.field-postalcode": "Postal Code",
  "settings.sections.settingsWebmail.signature.field-sn": "Lastname",
  "settings.sections.settingsWebmail.signature.field-st": "State",
  "settings.sections.settingsWebmail.signature.field-street": "Street",
  "settings.sections.settingsWebmail.signature.field-telephonenumber": "Company phone",
  "settings.sections.settingsWebmail.signature.field-title": "Role",
  "settings.sections.settingsWebmail.signature.subdesc":
    "Use tags to dynamically compose the signature template for all users. The tags will be replaced with the corresponding value present in the company registry.<br/>The {icon} symbol indicates that some users do not have the corresponding field set in their registry.",
  "settings.sections.settingsWebmail.signature.subtitle": "Available tags",
  "settings.sections.settingsWebmail.signature.title": "Centralized email signature",
  "settings.sections.settingsWebmail.title": "Webmail default settings for new email accounts",
  "settings.sections.settingsWebmailHideAddressbook.desc":
    "When creating a new email account for this domain, this one will not show up in the company addressbook.<br/><br/> This is the default settings, so after creation you can edit this settings on the email account directly.",
  "settings.sections.settingsWebmailHideAddressbook.title": "Company addressbook",
  "settings.sections.settingsWebmailHideAddressbookEmail.desc":
    "With this settings you can decide whether or not this user will be shown in the company addressbook",
  "settings.sections.tracemail21DaysLimit.desc":
    "Tracemail allows you to view logs up to 30 days, you can limit visibility to 21 days.",
  "settings.sections.tracemail21DaysLimit.title": "Tracemail log visibility",
  "settings.sections.tracemail21DaysLimitDefault.desc":
    "Tracemail allows you to view logs up to 30 days, you can limit visibility to 21 days for all new domains.",
  "settings.sections.tracemail21DaysLimitDefault.title": "Tracemail log visibility for new domains",
  "settings.sections.webhook.desc": "Set up a URL to receive a HTTP notification call.",
  "settings.sections.webhook.title": "Webhook",
  "settings.sections.webmailSignature.body":
    "Manage identities and signatures linked to the email account. <br/> Customize the display name and signauture for each identity.<br/> These settings enable you to send messages with names and addresses different from yours.",
  "settings.sections.webmailSignature.title": "Signatures & Identities",
  showPrices: "Show prices",
  "sidebar.category.analysis": "Analysis",
  "sidebar.category.importsMigrations": "Imports and Migrations",
  "sidebar.category.management": "Management",
  "sidebar.category.roles": "Roles",
  "sidebar.category.send": "Invio",
  "sidebar.item.account.email": "Accounts",
  "sidebar.item.admins": "Admin",
  "sidebar.item.alias.emails": "Email alias",
  "sidebar.item.archive": "Archive",
  "sidebar.item.auditLogs": "Audit log",
  "sidebar.item.customers": "Customers",
  "sidebar.item.customizations": "Customizations",
  "sidebar.item.dashboard": "Dashboard",
  "sidebar.item.delegates": "Delegates",
  "sidebar.item.domainProfiles": "Domain profiles",
  "sidebar.item.domains": "Domains",
  "sidebar.item.emailDelivery": "Email Delivery",
  "sidebar.item.emailDelivery.accounts": "Accounts",
  "sidebar.item.emailDelivery.suppressionList": "Suppression list",
  "sidebar.item.etlive": "Tracemail",
  "sidebar.item.home": "Home",
  "sidebar.item.imports": "Imports",
  "sidebar.item.managers": "Managers",
  "sidebar.item.migrationOptions": "Migration options",
  "sidebar.item.migrationStatus": "Qbmove",
  "sidebar.item.migrations": "Migrations",
  "sidebar.item.mtm_requests": "Restore requests",
  "sidebar.item.mx": "Custom MX",
  "sidebar.item.news": "News",
  "sidebar.item.orders": "Orders",
  "sidebar.item.orderslist": "Invoices",
  "sidebar.item.postmasters": "Postmaster",
  "sidebar.item.prices": "Prices",
  "sidebar.item.reports": "Reports",
  "sidebar.item.send.users": "Users",
  "sidebar.item.support": "Support",
  "sidebar.item.teamMembers": "Team",
  "signature.maxImageSize": "This image ({size}) exceed maximum size:",
  "signature.maxSize": "This signature ({size}) exceed maximum size:",
  "status.archiveActivating": "Activating archive",
  "status.completedWithErrors": "Completed with errors",
  "status.deleting": "Deleting",
  "status.disabled": "Disabled",
  "status.disabledByAdmin": "Disabled by admin",
  "status.disabledByCustomer": "Disabled by customer",
  "status.disabledByManager": "Disabled by manager",
  "status.disabledByVetting": "Disabled by vetting",
  "status.disabling": "Disabling",
  "status.enabled": "Enabled",
  "status.expired": "Expired",
  "status.failure": "Something went wrong, contact us",
  "status.failureLong": "Something went wrong, contact us",
  "status.invalidResources": "Not valid resources",
  "status.migrationInvalid": "Not valid",
  "status.scheduledDeleting": "Deleting will happen tonight",
  "status.unhealthy": "Domain active. Update or verify MX records",
  "status.updating": "Updating",
  "status.validWithSkipped": "Valid with skipped resources",
  "status.validating": "Validating",
  "status.validatingResources": "Validating resources",
  "status.waitingConfirmation": "Waiting for confirmation",
  "status.waitingOwnership": "Waiting for ownership check",
  "status.waitingPayment": "Waiting for payment",
  "support.ticket.desc":
    "Send a message to our technical support describing the problem as detailed as possible. We will reply as soon as possible.",
  "support.ticket.sent":
    "<b>Ticket successfully sent</b>.<br/>You will receive an email with the response from our technical support.",
  "support.ticket.title": "Do you need help?",
  "supportContactBox.cta": "Call our customer service",
  "supportContactBox.question": "Do you need help?",
  "supportContactBox.schedule": "Monday to Friday 09 am - 6 pm",
  "suppressionList.enabledDelivery": "Delivery enabled",
  "suppressionList.imports.add.desc":
    "Create the .CSV file with the necessary information and import up to 300 email addresses to the suppression list.",
  "tab.aliasDomains": "Domain alias",
  "tab.approval": "Approval",
  "tab.autoresponder": "Autoresponder",
  "tab.changePlan": "Change plan",
  "tab.connectedAccounts": "Accounts",
  "tab.customizations.domains": "For domains",
  "tab.customizations.general": "General",
  "tab.customizations.managers": "General of your managers",
  "tab.deleteAccount": "Delete account",
  "tab.delivery": "Email Delivery",
  "tab.deliveryLimits": "Email Delivery Limits",
  "tab.details": "Details",
  "tab.detailsAndSecurity": "Details and Security",
  "tab.domains": "Domains",
  "tab.emailAccounts": "Email accounts",
  "tab.emailAlias": "Email alias",
  "tab.emailArchive": "Email Archive",
  "tab.emailHosting": "Email Hosting",
  "tab.emailHostingLimits": "Email Hosting Limits",
  "tab.general": "General",
  "tab.limits": "Limits",
  "tab.notification": "Notification",
  "tab.orders": "Orders",
  "tab.owner": "Owner",
  "tab.postmaster": "Postmaster",
  "tab.registry": "Registry",
  "tab.security": "Security",
  "tab.serviceManagement": "Service management",
  "tab.settings": "Settings",
  "tab.trust": "Trust",
  "tab.verify": "Verification",
  "tab.verify.dns": "Verify by DNS",
  "tab.verify.email": "Verify by email",
  "tab.verify.html": "Verify by HTML",
  "tab.volumeManagement": "Available messages",
  "tab.volumeManagement.desc": "Set the number of messages available for the domain.",
  "tab.webmail": "Webmail",
  "table.header.account": "Account",
  "table.header.accounts": "Accounts",
  "table.header.accounts.100gb": "100Gb",
  "table.header.accounts.25gb": "25Gb",
  "table.header.accounts.50gb": "50Gb",
  "table.header.accounts.8gb": "8Gb",
  "table.header.accounts.archive": "Arch.",
  "table.header.alias": "Alias",
  "table.header.alias.domain": "D. alias",
  "table.header.alias.email": "E. alias",
  "table.header.code": "Code",
  "table.header.company": "Company",
  "table.header.country": "Country",
  "table.header.customer": "Customer",
  "table.header.customization": "Cust.",
  "table.header.date": "Date",
  "table.header.date.added": "Added",
  "table.header.date.creation": "Creation",
  "table.header.date.expiry": "Expiry",
  "table.header.delegates": "Delegates",
  "table.header.delivered": "Delivered",
  "table.header.delivery.account": "Account",
  "table.header.delivery.account.name": "Name",
  "table.header.delivery.account.username": "Username",
  "table.header.delivery.description": "Description",
  "table.header.delivery.suppressionList.account": "Account",
  "table.header.deliveryDomain.accounts": "Associated accounts",
  "table.header.description": "Description",
  "table.header.destinations": "Destinations",
  "table.header.domain": "Domain",
  "table.header.domains": "Domains",
  "table.header.ehawk": "Ehawk",
  "table.header.email": "Email",
  "table.header.error": "Error",
  "table.header.error_category": "Type",
  "table.header.errors": "Errors",
  "table.header.lastAccess": "Last access",
  "table.header.log1": "Log 1",
  "table.header.log2": "Log 2",
  "table.header.logo": "Logo",
  "table.header.managers": "Manager",
  "table.header.messagesIn24H": "Messages in 24h",
  "table.header.mx1": "MX 1",
  "table.header.mx2": "MX 2",
  "table.header.not.delivered": "Not delivered",
  "table.header.owner": "Owner",
  "table.header.plan": "Plan",
  "table.header.processed": "Processed",
  "table.header.quote": "Occupied space",
  "table.header.reason": "Reason",
  "table.header.remote.server": "Remote server",
  "table.header.remote.username": "Remote username",
  "table.header.resources": "Resources",
  "table.header.retention": "Retention",
  "table.header.scheduled.migration.first": "1st migration",
  "table.header.scheduled.migration.second": "2nd migration",
  "table.header.status": "Status",
  "table.header.supportURL": "Help desk URL",
  "table.header.suppressed": "Suppressed",
  "table.header.time": "Time",
  "table.header.type": "Type",
  "table.header.verification": "Verification",
  "table.header.who": "Author",
  "table.row.add.desc.customization": "Customize your domains with your company logo and name.",
  "table.row.add.desc.domain": "Add a domain to the list and start managing your email accounts.",
  "table.row.add.desc.domainAlias": "Add an alias domain to the list and start managing your alias.",
  "table.row.add.desc.emailAccout": "Add an email account to the list and start managing your accounts.",
  "table.row.add.desc.emailAlias": "Add an email alias to the list and start managing your alias.",
  "table.row.add.desc.import": "Add an import and enter all your domains and email accounts in the panel.",
  "table.row.add.desc.manager": "Add a manager and assign him the domains to manage.",
  "table.row.add.desc.migration": "Add a migration and transfer all your messages.",
  "table.row.add.desc.postmaster": "The Postmaster will be automatically created when each domain is added.",
  "table.row.add.desc.suppressionList": "Add single addresses or import them from a list.",
  "table.row.add.desc.teamMembers": "Add a team member and delegate the management of your domains.",
  "table.row.add.msg.customization": "Add customization",
  "table.row.add.msg.domain": "Add domain",
  "table.row.add.msg.domainAlias": "Add alias domain",
  "table.row.add.msg.emailAccout": "Add email account",
  "table.row.add.msg.emailAlias": "Add email alias",
  "table.row.add.msg.import": "Add import ",
  "table.row.add.msg.manager": "Add manager",
  "table.row.add.msg.migration": "Add migration",
  "table.row.add.msg.postmaster": "There are no Postmasters",
  "table.row.add.msg.suppressionList": "The suppression list is empty.",
  "table.row.add.msg.teamMembers": "Add team member",
  "table.row.desc.selectCustomer": "You must select a customer to access their suppression list.",
  "table.row.msg.selectCustomer": "Select a customer",
  "tag.signature.bcc": "Bcc",
  "tag.signature.default": "Default",
  "teamMembers.add.desc.step1": "Enter the contact information and set a password for the team member.",
  "teamMembers.add.desc.step2": "Set domains management permissions for the team member.",
  "teamMembers.add.desc.step3": "Set accounts management permissions for the team member.",
  "teamMembers.add.desc.step4": "Set the archive management permissions for the team member.",
  "teamMembers.add.desc.step5": "Set access to analysis tools for the team member.",
  "teamMembers.add.error.noPermission": "Must have at least 1 permission assigned",
  "teamMembers.add.title.step1": "New team member",
  "teamMembers.add.title.step2": "Domains management",
  "teamMembers.add.title.step3": "Accounts management",
  "teamMembers.add.title.step4": "Archives management",
  "teamMembers.add.title.step5": "Analysis and security tools",
  "teamMembers.forbiddenAction": "You do not have permissions to complete this action",
  "teamMembers.forbiddenActionSubtitle": "Contact the administrator to obtain the necessary permissions",
  "teamMembers.list.header.dsc":
    "Team members have access to the settings of all the domains and accounts present in them according to the limitations imposed by the administrator.",
  "teamMembers.list.header.title": "Team members",
  "tooltip.country": "Country",
  "tour.step1.description":
    "The Control Panel is packed with features.<br>Find out where to start and how to become a Power User.",
  "tour.step1.title": "Here are 3 tips to become a Power User",
  "tour.step2.description": "In the Management section you can:",
  "tour.step2.listItem1": "Managing the <b>quota</b> of mailboxes",
  "tour.step2.listItem2": "Change <b>plan</b> for domains",
  "tour.step2.listItem3": "Setting the Policy for <b>Security</b>",
  "tour.step2.listItem4": "Create centralised <b>email signatures</b>",
  "tour.step2.listItem5": "Customise the service with <b>your logo</b>",
  "tour.step2.listItem6": "And much more...",
  "tour.step2.title": "Create and manage domains and email accounts",
  "tour.step3.description": "Create different Roles for the management of your customers' mailboxes:",
  "tour.step3.listItem1": "<b>Team</b> - Create accounts for your employees",
  "tour.step3.listItem2": "<b>Postmaster</b> - Allow your customers to manage their domains",
  "tour.step3.listItem3": "<b>Manager</b> - Resell the service to other resellers",
  "tour.step3.title": "The Control Panel is Multi-Level",
  "tour.step4.description": "Quickly identify email management problems, save time and frustration:",
  "tour.step4.listItem1": "<b>Tracemail</b> - Identifies access and deliverability issues",
  "tour.step4.listItem2": "<b>Audit log</b> - Monitors any activity carried out by accounts under management",
  "tour.step4.listItem3": "<b>Report</b> - Generates reports on active Control Panel accounts",
  "tour.step4.title": "Analysis Tools and Help Desk",
  "tour.step5.content": "Your tour is here!",
};
